export default {
    "Admin": {
        "STATUS_PROVISIONED": "provisioned",
        "STATUS_REGISTERED": "registered",
        "STATUS_SUSPENDED": "suspended",
        "STATUS_DELETED": "deleted"
    },
    "ApplicationSheetFormat": {
        "APPLICATION_TEMPLATE_FILE_NAME": "keikaku_shinrin_template.xlsx",
        "SHEET1": "\u3010\u5438\u53ce\u91cf(\u80b2\u6210\u6797)\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8",
        "SHEET2": "\u3010\u5438\u53ce\u91cf(\u5929\u7136\u751f\u6797)\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8",
        "OUTPUT_ITEM_CODE_PREFECTURE": "0001",
        "OUTPUT_ITEM_CODE_YEAR": "0002",
        "SHEET1_OUTPUT_ITEM_CODE_CITY": "1004",
        "SHEET1_OUTPUT_ITEM_CODE_CITY_LARGE_LETTER": "1005",
        "SHEET1_OUTPUT_ITEM_CODE_HOUSE_NUMBER": "1006",
        "SHEET1_OUTPUT_ITEM_CODE_FOREST_GROUP": "1007",
        "SHEET1_OUTPUT_ITEM_CODE_SMALL_FOREST_GROUP": "1008",
        "SHEET1_OUTPUT_ITEM_CODE_BRANCH_GROUP": "1009",
        "SHEET1_OUTPUT_ITEM_CODE_AREA": "1015",
        "SHEET1_OUTPUT_ITEM_CODE_TREE_SPECIES": "1016",
        "SHEET1_OUTPUT_ITEM_CODE_FOREST_AGE": "1017",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_TYPE1": "1018",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_HISTORY_THINNING_YEAR": "1019",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_HISTORY_THINNING_AREA": "1020",
        "SHEET1_OUTPUT_ITEM_CODE_ANOTHER_DISPLAY_OF_THE_FELLING_PLAN_MAIN_THINNING": "1021",
        "SHEET1_OUTPUT_ITEM_CODE_FELLING_PLANNING_YEAR": "1022",
        "SHEET1_OUTPUT_ITEM_CODE_PLANNED_FELLING_AREA": "1023",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_TYPE2": "1024",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_HISTORY_THINNING_YEAR2": "1025",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_HISTORY_THINNING_AREA2": "1026",
        "SHEET1_OUTPUT_ITEM_CODE_OPERATION_POSITION": "1030",
        "SHEET2_OUTPUT_ITEM_CODE_CITY": "2002",
        "SHEET2_OUTPUT_ITEM_CODE_CITY_LARGE_LETTER": "2003",
        "SHEET2_OUTPUT_ITEM_CODE_HOUSE_NUMBER": "2004",
        "SHEET2_OUTPUT_ITEM_CODE_FOREST_GROUP": "2005",
        "SHEET2_OUTPUT_ITEM_CODE_SMALL_FOREST_GROUP": "2006",
        "SHEET2_OUTPUT_ITEM_CODE_BRANCH_GROUP": "2007",
        "SHEET2_OUTPUT_ITEM_CODE_AREA": "2013",
        "SHEET2_OUTPUT_ITEM_CODE_TREE_SPECIES": "2014",
        "SHEET2_OUTPUT_ITEM_CODE_FOREST_AGE": "2015",
        "SHEET2_OUTPUT_ITEM_CODE_OPERATION_ACCUMULATION": "2019",
        "SHEET2_OUTPUT_ITEM_CODE_OPERATION_POSITION": "2020"
    },
    "AuthenticationApplicationForm": {
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPE_YES": 1,
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPE_NO": 2,
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPE_YES_LABEL": "\u6709",
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPE_NO_LABEL": "\u7121",
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPE_OPTIONS": [
            {
                "key": 1,
                "label": "\u6709"
            },
            {
                "key": 2,
                "label": "\u7121"
            }
        ],
        "EXAMINATION_COST_SUPPORT_CONJUGATION_TYPES": {
            "1": "\u6709",
            "2": "\u7121"
        },
        "VERIFICATION_AUTHORITY_TYPE_JMA": 1,
        "VERIFICATION_AUTHORITY_TYPE_JQAO": 2,
        "VERIFICATION_AUTHORITY_TYPE_JMTA": 3,
        "VERIFICATION_AUTHORITY_TYPE_SCJC": 4,
        "VERIFICATION_AUTHORITY_TYPE_JMA_LABEL": "\u4e00\u822c\u793e\u56e3\u6cd5\u4eba \u65e5\u672c\u80fd\u7387\u5354\u4f1a",
        "VERIFICATION_AUTHORITY_TYPE_JQAO_LABEL": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u54c1\u8cea\u4fdd\u8a3c\u6a5f\u69cb",
        "VERIFICATION_AUTHORITY_TYPE_JMTA_LABEL": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u6d77\u4e8b\u5354\u4f1a",
        "VERIFICATION_AUTHORITY_TYPE_SCJC_LABEL": "\u30bd\u30b3\u30c6\u30c3\u30af\u30fb\u30b5\u30fc\u30c6\u30a3\u30d5\u30a3\u30b1\u30fc\u30b7\u30e7\u30f3\u30fb\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e",
        "VERIFICATION_AUTHORITY_TYPE_OPTIONS": [
            {
                "key": 1,
                "label": "\u4e00\u822c\u793e\u56e3\u6cd5\u4eba \u65e5\u672c\u80fd\u7387\u5354\u4f1a"
            },
            {
                "key": 2,
                "label": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u54c1\u8cea\u4fdd\u8a3c\u6a5f\u69cb"
            },
            {
                "key": 3,
                "label": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u6d77\u4e8b\u5354\u4f1a"
            },
            {
                "key": 4,
                "label": "\u30bd\u30b3\u30c6\u30c3\u30af\u30fb\u30b5\u30fc\u30c6\u30a3\u30d5\u30a3\u30b1\u30fc\u30b7\u30e7\u30f3\u30fb\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e"
            }
        ]
    },
    "BroadcastMailLog": {
        "STATUS_REGISTERED": "registered",
        "STATUS_EXECUTING": "executing",
        "STATUS_FINISHED": "finished",
        "STATUS_FAILED": "failed"
    },
    "CDivision": {
        "DIVISION_ID_DEVELOPMENT": 1,
        "DIVISION_ID_GENERAL_AFFAIRS": 10001
    },
    "CMailFromAddressHistory": {
        "OPERATOR_TYPE_MEMBER": "member",
        "OPERATOR_TYPE_SYSTEM": "system"
    },
    "CMemberHistory": {
        "OPERATOR_TYPE_SYSTEM": "system",
        "OPERATOR_TYPE_MEMBER": "member"
    },
    "CreationCostSubsidyDetails": {
        "UNIT_YEN_ID": 1,
        "UNIT_YEN_LABEL": "\u5186",
        "UNIT_YEN_HA_ID": 2,
        "UNIT_YEN_HA_LABEL": "\u5186\/ha",
        "UNIT_OPTIONS": [
            {
                "id": 1,
                "label": "\u5186"
            },
            {
                "id": 2,
                "label": "\u5186\/ha"
            }
        ],
        "INIT_VALUE": 0,
        "TYPE_COST": 1,
        "TYPE_SUBSIDY": 2,
        "INIT_COST_LIST": [
            "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u66f8\u4f5c\u6210\uff0b\u5be9\u67fb\u652f\u63f4",
            "\u59a5\u5f53\u6027\u78ba\u8a8d\u5be9\u67fb\u8cbb\u7528",
            "\u68ee\u6797\u306e\u4fdd\u8b77\u30fb\u5de1\u8996",
            "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u68ee\u6797\u8a08\u6e2c",
            "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u66f8\u985e\u4f5c\u6210\uff0b\u5be9\u67fb\u652f\u63f4",
            "\u691c\u8a3c\u5be9\u67fb\u8cbb\u7528"
        ],
        "INIT_SUBSIDY_NAME": "\u672a\u8a2d\u5b9a"
    },
    "CreditSummary": {
        "CATEGORY": "FO",
        "NUMBER_1": 1,
        "NUMBER_1_LABEL": "001",
        "NUMBER_2": 2,
        "NUMBER_2_LABEL": "002",
        "NUMBER_3": 3,
        "NUMBER_3_LABEL": "003",
        "CONTENT_TYPE_NORMAL": 1,
        "CONTENT_TYPE_NORMAL_LABEL": "\u901a\u5e38\u578b",
        "CONTENT_TYPE_PROGRAM": 2,
        "CONTENT_TYPE_PROGRAM_LABEL": "\u30d7\u30ed\u30b0\u30e9\u30e0\u578b",
        "ACTIVITY_TYPE_ONLY_ABSORPTION": 1,
        "ACTIVITY_TYPE_ONLY_ABSORPTION_LABEL": "\u5438\u53ce\u91cf\u306e\u307f",
        "ACTIVITY_TYPE_ABSORPTION_AND_PRODUCTION": 2,
        "ACTIVITY_TYPE_ABSORPTION_AND_PRODUCTION_LABEL": "\u5438\u53ce\u91cf\uff0b\u518d\u9020\u6797",
        "ACTIVITY_TYPE_ABSORPTION_AND_REFORESTATION": 3,
        "ACTIVITY_TYPE_ABSORPTION_AND_REFORESTATION_LABEL": "\u5438\u53ce\u91cf\uff0b\u4f10\u63a1\u6728\u6750\u88fd\u54c1",
        "ACTIVITY_TYPE_ABSORPTION_AND_REFORESTATION_AND_PRODUCTION": 4,
        "ACTIVITY_TYPE_ABSORPTION_AND_REFORESTATION_AND_PRODUCTION_LABEL": "\u5438\u53ce\u91cf\uff0b\u518d\u9020\u6797\uff0b\u4f10\u63a1\u6728\u6750\u88fd\u54c1",
        "RATIO_ISSUANCE_AMOUNT": 0.97,
        "RATIO_BUFFER_AMOUNT": 0.03
    },
    "CustomForestManagementPlanDetail": {
        "AREA_TYPE_NONE": 99,
        "AREA_TYPE_ACTUAL_VALUE": 1,
        "AREA_TYPE_ESTIMATED_VALUE": 2,
        "AREA_TYPE_NONE_LABEL": "\u5909\u66f4\u306a\u3057",
        "AREA_TYPE_ACTUAL_LABEL": "\u5b9f\u6e2c\u5024",
        "AREA_TYPE_ESTIMATED_LABEL": "\u60f3\u5b9a\u5024",
        "AREA_TYPE_OPTIONS": [
            {
                "id": 99,
                "label": "\u5909\u66f4\u306a\u3057"
            },
            {
                "id": 1,
                "label": "\u5b9f\u6e2c\u5024"
            },
            {
                "id": 2,
                "label": "\u60f3\u5b9a\u5024"
            }
        ],
        "POSITION_TYPE_NONE": 99,
        "POSITION_TYPE_ACTUAL_VALUE": 1,
        "POSITION_TYPE_ESTIMATED_VALUE": 2,
        "POSITION_TYPE_NONE_LABEL": "\u5909\u66f4\u306a\u3057",
        "POSITION_TYPE_ACTUAL_LABEL": "\u5b9f\u6e2c\u5024",
        "POSITION_TYPE_ESTIMATED_LABEL": "\u60f3\u5b9a\u5024",
        "POSITION_TYPE_OPTIONS": [
            {
                "id": 99,
                "label": "\u5909\u66f4\u306a\u3057"
            },
            {
                "id": 1,
                "label": "\u5b9f\u6e2c\u5024"
            },
            {
                "id": 2,
                "label": "\u60f3\u5b9a\u5024"
            }
        ],
        "BULK_APPLICATION_STATUS_NONE": 99,
        "BULK_APPLICATION_STATUS_FALSE": 0,
        "BULK_APPLICATION_STATUS_TRUE": 1,
        "BULK_APPLICATION_STATUS_NONE_LABEL": "\u5909\u66f4\u306a\u3057",
        "BULK_APPLICATION_STATUS_FALSE_LABEL": "\u7121",
        "BULK_APPLICATION_STATUS_TRUE_LABEL": "\u6709",
        "BULK_APPLICATION_STATUS_OPTIONS": [
            {
                "id": 99,
                "label": "\u5909\u66f4\u306a\u3057"
            },
            {
                "id": 0,
                "label": "\u7121"
            },
            {
                "id": 1,
                "label": "\u6709"
            }
        ],
        "FOREST_PROTECTION_ACTIVITY_TYPE_NONE": 99,
        "FOREST_PROTECTION_ACTIVITY_TYPE_PEST_CONTROL": 1,
        "FOREST_PROTECTION_ACTIVITY_TYPE_FIRE_PREVENTION": 2,
        "FOREST_PROTECTION_ACTIVITY_TYPE_NONE_LABEL": "\u5909\u66f4\u306a\u3057",
        "FOREST_PROTECTION_ACTIVITY_TYPE_PEST_CONTROL_LABEL": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632",
        "FOREST_PROTECTION_ACTIVITY_TYPE_FIRE_PREVENTION_LABEL": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5",
        "FOREST_PROTECTION_ACTIVITY_TYPE_OPTIONS": [
            {
                "id": 99,
                "label": "\u5909\u66f4\u306a\u3057"
            },
            {
                "id": 1,
                "label": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632"
            },
            {
                "id": 2,
                "label": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5"
            }
        ],
        "PROJECT_EXECUTION_AREA_ADDED": true,
        "PROJECT_EXECUTION_AREA_ADDED_INT": 1,
        "PROJECT_EXECUTION_AREA_NOT_ADDED": false,
        "RESTRICTED_EXECUTION_AREA_ALLOWED": false,
        "RESTRICTED_EXECUTION_AREA_FORBIDDEN": true
    },
    "DataExportedLog": {
        "TARGET_INDEX_CUSTOMER": 1,
        "TARGET_INDEX_CENTER_EMISSION": 2,
        "TARGET_INDEX_FOREST_MANAGEMENT": 3
    },
    "DataImportStatus": {
        "STATUS_NOT_STARTED": 0,
        "STATUS_IMPORTING": 1,
        "STATUS_SUCCESS": 2,
        "STATUS_FAILED": 3,
        "PROJECT_APPLICATION_DATA_KIND": "project_application",
        "PROJECT_APPLICATION_MESSAGE": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u66f8\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f",
        "MONITORING_PLOTS_DATA_KIND": "monitoring_plots",
        "MONITORING_PLOTS_MESSAGE": "\u5730\u56f3\u753b\u50cf\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f",
        "OTHER_DOCUMENTS_DATA_KIND": "other_documents",
        "OTHER_DOCUMENTS_MESSAGE": "\u305d\u306e\u4ed6\u66f8\u985e\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u306b\u6210\u529f\u3057\u307e\u3057\u305f\u3002",
        "MONITORING_REPORT_DOCUMENT_DATA_KIND": "monitoring_report_document",
        "MONITORING_REPORT_DOCUMENT_MESSAGE": "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5831\u544a\u66f8\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f",
        "PLAN_CHANGE_DOCUMENT_DATA_KIND": "plan_change_document",
        "PLAN_CHANGE_DOCUMENT_MESSAGE": "\u8a08\u753b\u5909\u66f4\u5c4a\u306e\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u304c\u5b8c\u4e86\u3057\u307e\u3057\u305f"
    },
    "Fcs": {
        "FcsApplicationCandidate": {
            "USED_FOR_CALCULATION_STATUS": 1
        },
        "FcsCertificationPeriodSetting": {
            "CERTIFICATION_PERIOD": {
                "key": "certification_period",
                "text": "\u8a8d\u8a3c\u5bfe\u8c61\u671f\u9593"
            },
            "SETTING_OPTIONS_DEFAULT": [
                {
                    "key": "certification_period",
                    "text": "\u8a8d\u8a3c\u5bfe\u8c61\u671f\u9593"
                }
            ]
        },
        "FcsForestManagementPlan": {
            "NOT_CREDITED": 0,
            "IS_CREDITED": 1,
            "IMPORT_CSV_HEADER_COLUMNS": {
                "1": {
                    "column": "class_id",
                    "label": "\u5c0f\u73ed\uff29\uff24",
                    "rule": "string"
                },
                "2": {
                    "column": "territory_distinction",
                    "label": "\u5730\u7a2e\u533a\u5206",
                    "rule": "string"
                },
                "3": {
                    "column": "forest_species",
                    "label": "\u5730\u7a2e\u533a\u5206\u8868\u793a",
                    "rule": "nullable|string|exists:fcs_forest_species,forest_species",
                    "save_column": "fcs_forest_species_id",
                    "repository": "App\\Repositories\\Member\\Fcs\\FcsForestSpeciesRepository"
                },
                "4": {
                    "column": "serial number",
                    "label": "\u4e00\u9023\u756a\u53f7",
                    "rule": "nullable|string"
                },
                "5": {
                    "column": "forest_group",
                    "label": "\u6797\u73ed",
                    "rule": "required|string|max:10"
                },
                "6": {
                    "column": "forest_group_display",
                    "label": "\u6797\u73ed\u8868\u793a",
                    "rule": "nullable|string"
                },
                "7": {
                    "column": "small_forest_group",
                    "label": "\u5c0f\u73ed\u8a18\u53f7",
                    "rule": "required|string|max:10"
                },
                "8": {
                    "column": "small_forest_group_display",
                    "label": "\u5c0f\u73ed\u8a18\u53f7\u8868\u793a",
                    "rule": "nullable|string"
                },
                "9": {
                    "column": "small_forest_group_number",
                    "label": "\u5c0f\u73ed\u756a\u53f7",
                    "rule": "nullable|string"
                },
                "10": {
                    "column": "small_forest_group_number_display",
                    "label": "\u5c0f\u73ed\u756a\u53f7\u8868\u793a",
                    "rule": "nullable|string"
                },
                "11": {
                    "column": "branch_group",
                    "label": "\u5c0f\u73ed\u679d\u756a",
                    "rule": "nullable|string|max:255"
                },
                "12": {
                    "column": "branch_group_display",
                    "label": "\u5c0f\u73ed\u679d\u756a\u8868\u793a",
                    "rule": "nullable|string"
                },
                "13": {
                    "column": "prefecture_id",
                    "label": "\u68ee\u6797\u90fd\u9053\u5e9c\u770c",
                    "rule": "nullable|exists:master_prefectures,id"
                },
                "14": {
                    "column": "prefecture_display",
                    "label": "\u68ee\u6797\u90fd\u9053\u5e9c\u770c\u8868\u793a",
                    "rule": "nullable|string"
                },
                "15": {
                    "column": "city_id",
                    "label": "\u68ee\u6797\u5e02\u753a\u6751",
                    "rule": "nullable|string"
                },
                "16": {
                    "column": "city",
                    "label": "\u68ee\u6797\u5e02\u753a\u6751\u8868\u793a",
                    "rule": "nullable|string"
                },
                "17": {
                    "column": "city_large_letter_id",
                    "label": "\u68ee\u6797\u4f4f\u6240\u5927\u5b57",
                    "rule": "nullable|string"
                },
                "18": {
                    "column": "city_large_letter",
                    "label": "\u68ee\u6797\u4f4f\u6240\u5927\u5b57\u8868\u793a",
                    "rule": "nullable|string"
                },
                "19": {
                    "column": "forest_address_letter",
                    "label": "\u68ee\u6797\u4f4f\u6240\u5b57",
                    "rule": "nullable|string"
                },
                "20": {
                    "column": "house_number",
                    "label": "\u68ee\u6797\u4f4f\u6240\u5730\u756a",
                    "rule": "nullable|string"
                },
                "21": {
                    "column": "owner_prefecture",
                    "label": "\u6240\u6709\u8005\u90fd\u9053\u5e9c\u770c",
                    "rule": "nullable|string"
                },
                "22": {
                    "column": "owner_prefecture_display",
                    "label": "\u6240\u6709\u8005\u90fd\u9053\u5e9c\u770c\u8868\u793a",
                    "rule": "nullable|string"
                },
                "23": {
                    "column": "owner_city",
                    "label": "\u6240\u6709\u8005\u5e02\u753a\u6751",
                    "rule": "nullable|string"
                },
                "24": {
                    "column": "owner_city_display",
                    "label": "\u6240\u6709\u8005\u5e02\u753a\u6751\u8868\u793a",
                    "rule": "nullable|string"
                },
                "25": {
                    "column": "owner_name_kana",
                    "label": "\u6240\u6709\u8005\u6c0f\u540d\u30ab\u30bf\u30ab\u30ca",
                    "rule": "nullable|string"
                },
                "26": {
                    "column": "owner_same_name_category",
                    "label": "\u6240\u6709\u8005\u540c\u540d\u533a\u5206",
                    "rule": "nullable|string"
                },
                "27": {
                    "column": "number_of_co_owners",
                    "label": "\u5171\u6709\u8005\u6570",
                    "rule": "nullable|string"
                },
                "28": {
                    "column": "owner_id",
                    "label": "\u6240\u6709\u5f62\u614b",
                    "rule": "nullable|integer"
                },
                "29": {
                    "column": "owner",
                    "label": "\u6240\u6709\u5f62\u614b\u8868\u793a",
                    "rule": "nullable|string"
                },
                "30": {
                    "column": "area",
                    "label": "\u9762\u7a4d",
                    "rule": "nullable|numeric"
                },
                "31": {
                    "column": "fcs_forest_species_id_value",
                    "label": "\u6797\u7a2e",
                    "rule": "nullable"
                },
                "32": {
                    "column": "forest_species_name",
                    "label": "\u6797\u7a2e\u8868\u793a",
                    "rule": "nullable|string"
                },
                "33": {
                    "column": "tree_species_number",
                    "label": "\u6a39\u7a2e",
                    "rule": "nullable|string"
                },
                "34": {
                    "column": "tree_species",
                    "label": "\u6a39\u7a2e\u8868\u793a",
                    "rule": "nullable"
                },
                "35": {
                    "column": "blending_rate",
                    "label": "\u6df7\u4ea4\u6b69\u5408",
                    "rule": "nullable|string"
                },
                "36": {
                    "column": "forest_age",
                    "label": "\u6797\u9f62",
                    "rule": "nullable|integer|digits_between:1,4"
                },
                "37": {
                    "column": "sparse_density",
                    "label": "\u758e\u5bc6\u5ea6",
                    "rule": "nullable"
                },
                "38": {
                    "column": "tree_height",
                    "label": "\u6a39\u9ad8",
                    "rule": "nullable|numeric"
                },
                "39": {
                    "column": "yield_ratio_number",
                    "label": "\u53ce\u91cf\u6bd4\u6570",
                    "rule": "nullable"
                },
                "40": {
                    "column": "timber_volume_per_ha",
                    "label": "ha\u5f53\u305f\u308a\u306e\u6750\u7a4d",
                    "rule": "nullable"
                },
                "41": {
                    "column": "standing_wood_volume",
                    "label": "\u7acb\u6728\u6750\u7a4d",
                    "rule": "nullable"
                },
                "42": {
                    "column": "growth_rate",
                    "label": "\u6210\u9577\u7387",
                    "rule": "nullable"
                },
                "43": {
                    "column": "annual_growth",
                    "label": "\u9023\u5e74\u6210\u9577\u91cf",
                    "rule": "nullable"
                },
                "44": {
                    "column": "number_of_trees_planted_per_ha",
                    "label": "ha\u5f53\u305f\u308a\u306e\u690d\u683d\u672c\u6570",
                    "rule": "nullable"
                },
                "45": {
                    "column": "position",
                    "label": "\u5730\u4f4d",
                    "rule": "nullable"
                },
                "46": {
                    "column": "forest_type",
                    "label": "\u68ee\u6797\u306e\u7a2e\u985e",
                    "rule": "nullable"
                },
                "47": {
                    "column": "forest_type_display",
                    "label": "\u68ee\u6797\u306e\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "48": {
                    "column": "type_of_restricted_forest",
                    "label": "\u5236\u9650\u6797\u306e\u7a2e\u985e",
                    "rule": "nullable"
                },
                "49": {
                    "column": "type_of_restricted_forest_display",
                    "label": "\u5236\u9650\u6797\u306e\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "50": {
                    "column": "logging_method",
                    "label": "\u4f10\u63a1\u306e\u65b9\u6cd5\u7b49",
                    "rule": "nullable"
                },
                "51": {
                    "column": "logging_method_display",
                    "label": "\u4f10\u63a1\u306e\u65b9\u6cd5\u7b49\u8868\u793a",
                    "rule": "nullable"
                },
                "52": {
                    "column": "update_method",
                    "label": "\u66f4\u65b0\u306e\u65b9\u6cd5\u7b49",
                    "rule": "nullable"
                },
                "53": {
                    "column": "update_method_display",
                    "label": "\u66f4\u65b0\u306e\u65b9\u6cd5\u7b49\u8868\u793a",
                    "rule": "nullable"
                },
                "54": {
                    "column": "target_year_for_conversion_completion",
                    "label": "\u8ee2\u63db\u5b8c\u4e86\u76ee\u6a19\u5e74\u5ea6",
                    "rule": "nullable"
                },
                "55": {
                    "column": "target_year_for_conversion_completion_display",
                    "label": "\u8ee2\u63db\u5b8c\u4e86\u76ee\u6a19\u5e74\u5ea6\u8868\u793a",
                    "rule": "nullable"
                },
                "56": {
                    "column": "forest_requiring_thinning",
                    "label": "\u8981\u9593\u4f10\u68ee\u6797",
                    "rule": "nullable"
                },
                "57": {
                    "column": "forest_requiring_thinning_display",
                    "label": "\u8981\u9593\u4f10\u68ee\u6797\u8868\u793a",
                    "rule": "nullable"
                },
                "58": {
                    "column": "designated_year_for_thinning",
                    "label": "\u8981\u9593\u4f10\u6307\u5b9a\u5e74\u5ea6",
                    "rule": "nullable"
                },
                "59": {
                    "column": "designated_year_for_thinning_display",
                    "label": "\u8981\u9593\u4f10\u6307\u5b9a\u5e74\u5ea6\u8868\u793a",
                    "rule": "nullable"
                },
                "60": {
                    "column": "implementation_status_of_required_thinning",
                    "label": "\u8981\u9593\u4f10\u5b9f\u65bd\u72b6\u6cc1",
                    "rule": "nullable"
                },
                "61": {
                    "column": "implementation_status_of_required_thinning_display",
                    "label": "\u8981\u9593\u4f10\u5b9f\u65bd\u72b6\u6cc1\u8868\u793a",
                    "rule": "nullable"
                },
                "62": {
                    "column": "category_of_thinning_operation",
                    "label": "\u9593\u4f10\u65bd\u696d\u306e\u533a\u5206",
                    "rule": "nullable"
                },
                "63": {
                    "column": "category_of_thinning_operation_display",
                    "label": "\u9593\u4f10\u65bd\u696d\u306e\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "64": {
                    "column": "types_of_forest_thinning_operations",
                    "label": "\u9593\u4f10\u65bd\u696d\u306e\u7a2e\u985e",
                    "rule": "nullable"
                },
                "65": {
                    "column": "types_of_forest_thinning_operations_display",
                    "label": "\u9593\u4f10\u65bd\u696d\u306e\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "66": {
                    "column": "fcs_operation_id_1",
                    "label": "\u9593\u4f10\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "67": {
                    "column": "fcs_operation_1_display",
                    "label": "\u9593\u4f10\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "68": {
                    "column": "classification_of_maintenance_operations",
                    "label": "\u6574\u5099\u65bd\u696d\u306e\u533a\u5206",
                    "rule": "nullable"
                },
                "69": {
                    "column": "classification_of_maintenance_operations_display",
                    "label": "\u6574\u5099\u65bd\u696d\u306e\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "70": {
                    "column": "type_of_maintenance_operation",
                    "label": "\u6574\u5099\u65bd\u696d\u306e\u7a2e\u985e",
                    "rule": "nullable"
                },
                "71": {
                    "column": "type_of_maintenance_operation_display",
                    "label": "\u6574\u5099\u65bd\u696d\u306e\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "72": {
                    "column": "maintenance_time",
                    "label": "\u6574\u5099\u6642\u671f",
                    "rule": "nullable"
                },
                "73": {
                    "column": "maintenance_time_display",
                    "label": "\u6574\u5099\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "74": {
                    "column": "forests_not_covered_by_plan",
                    "label": "\u8a08\u753b\u5bfe\u8c61\u5916\u7b49\u68ee\u6797",
                    "rule": "nullable"
                },
                "75": {
                    "column": "forests_not_covered_by_plan_display",
                    "label": "\u8a08\u753b\u5bfe\u8c61\u5916\u7b49\u68ee\u6797\u8868\u793a",
                    "rule": "nullable"
                },
                "76": {
                    "column": "special_1",
                    "label": "\u7279\u6b8a\uff11",
                    "rule": "nullable"
                },
                "77": {
                    "column": "special_1_display",
                    "label": "\u7279\u6b8a\uff11\u8868\u793a",
                    "rule": "nullable"
                },
                "78": {
                    "column": "special_2",
                    "label": "\u7279\u6b8a\uff12",
                    "rule": "nullable"
                },
                "79": {
                    "column": "special_2_display",
                    "label": "\u7279\u6b8a\uff12\u8868\u793a",
                    "rule": "nullable"
                },
                "80": {
                    "column": "standard_cutting_age",
                    "label": "\u6a19\u6e96\u4f10\u671f\u9f62",
                    "rule": "nullable|numeric"
                },
                "81": {
                    "column": "management_form",
                    "label": "\u7d4c\u55b6\u5f62\u614b",
                    "rule": "nullable"
                },
                "82": {
                    "column": "management_form_display",
                    "label": "\u7d4c\u55b6\u5f62\u614b\u8868\u793a",
                    "rule": "nullable"
                },
                "83": {
                    "column": "fcs_operation_id_2",
                    "label": "\u65bd\u696d\u5c65\u6b74\u9593\u4f10\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "84": {
                    "column": "fcs_operation_2_display",
                    "label": "\u65bd\u696d\u5c65\u6b74\u9593\u4f10\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "85": {
                    "column": "operation_history_thinning_area",
                    "label": "\u65bd\u696d\u5c65\u6b74\u9593\u4f10\u9762\u7a4d",
                    "rule": "nullable|numeric"
                },
                "86": {
                    "column": "fcs_operation_id_3",
                    "label": "\u65bd\u696d\u5c65\u6b74\u4e3b\u4f10\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "87": {
                    "column": "fcs_operation_3_display",
                    "label": "\u65bd\u696d\u5c65\u6b74\u4e3b\u4f10\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "88": {
                    "column": "operation_history_main_cutting_area",
                    "label": "\u65bd\u696d\u5c65\u6b74\u4e3b\u4f10\u9762\u7a4d",
                    "rule": "nullable"
                },
                "89": {
                    "column": "fcs_operation_id_4",
                    "label": "\u4f10\u63a1\u8a08\u753b\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "90": {
                    "column": "fcs_operation_4_display",
                    "label": "\u4f10\u63a1\u8a08\u753b\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "91": {
                    "column": "logging_plan_main_thinning",
                    "label": "\u4f10\u63a1\u8a08\u753b\u4e3b\u4f10\u9593\u4f10\u306e\u5225",
                    "rule": "nullable"
                },
                "92": {
                    "column": "another_display_of_the_felling_plan_main_thinning",
                    "label": "\u4f10\u63a1\u8a08\u753b\u4e3b\u4f10\u9593\u4f10\u306e\u5225\u8868\u793a",
                    "rule": "nullable"
                },
                "93": {
                    "column": "deforestation_plan_clear_felling_selective_felling",
                    "label": "\u4f10\u63a1\u8a08\u753b\u7686\u4f10\u629e\u4f10\u7b49\u5225",
                    "rule": "nullable"
                },
                "94": {
                    "column": "deforestation_plan_clear_felling_selective_felling_display",
                    "label": "\u4f10\u63a1\u8a08\u753b\u7686\u4f10\u629e\u4f10\u7b49\u5225\u8868\u793a",
                    "rule": "nullable"
                },
                "95": {
                    "column": "planned_logging_rate",
                    "label": "\u8a08\u753b\u4f10\u63a1\u7387",
                    "rule": "nullable"
                },
                "96": {
                    "column": "planned_felling_area",
                    "label": "\u4f10\u63a1\u8a08\u753b\u9762\u7a4d",
                    "rule": "nullable"
                },
                "97": {
                    "column": "felling_planning_timber_volume",
                    "label": "\u4f10\u63a1\u8a08\u753b\u7acb\u6728\u6750\u7a4d",
                    "rule": "nullable"
                },
                "98": {
                    "column": "fcs_operation_id_5",
                    "label": "\u9020\u6797\u8a08\u753b\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "99": {
                    "column": "fcs_operation_5_display",
                    "label": "\u9020\u6797\u8a08\u753b\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "100": {
                    "column": "afforestation_planning_method",
                    "label": "\u9020\u6797\u8a08\u753b\u65b9\u6cd5",
                    "rule": "nullable"
                },
                "101": {
                    "column": "afforestation_planning_method_display",
                    "label": "\u9020\u6797\u8a08\u753b\u65b9\u6cd5\u8868\u793a",
                    "rule": "nullable"
                },
                "102": {
                    "column": "afforestation_plan_tree_species",
                    "label": "\u9020\u6797\u8a08\u753b\u6a39\u7a2e",
                    "rule": "nullable"
                },
                "103": {
                    "column": "afforestation_plan_tree_species_display",
                    "label": "\u9020\u6797\u8a08\u753b\u6a39\u7a2e\u8868\u793a",
                    "rule": "nullable"
                },
                "104": {
                    "column": "afforestation_plan_area",
                    "label": "\u9020\u6797\u8a08\u753b\u9762\u7a4d",
                    "rule": "nullable"
                },
                "105": {
                    "column": "afforestation_plan_planting_number",
                    "label": "\u9020\u6797\u8a08\u753b\u690d\u683d\u672c\u6570",
                    "rule": "nullable"
                },
                "106": {
                    "column": "nursery_plan_area",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u9762\u7a4d",
                    "rule": "nullable"
                },
                "107": {
                    "column": "childcare_plan_weeding_plan_once_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e741\u56de\u6570",
                    "rule": "nullable"
                },
                "108": {
                    "column": "childcare_plan_weeding_plan_twice_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e742\u56de\u6570",
                    "rule": "nullable"
                },
                "109": {
                    "column": "childcare_plan_weeding_plan_3_times_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e743\u56de\u6570",
                    "rule": "nullable"
                },
                "110": {
                    "column": "childcare_plan_weeding_plan_4_times_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e744\u56de\u6570",
                    "rule": "nullable"
                },
                "111": {
                    "column": "childcare_plan_weeding_plan_5_times_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e745\u56de\u6570",
                    "rule": "nullable"
                },
                "112": {
                    "column": "childcare_plan_weeding_plan_6_times_a_year",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u4e0b\u5208\u8a08\u753b\u5e746\u56de\u6570",
                    "rule": "nullable"
                },
                "113": {
                    "column": "fcs_operation_id_6",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed61\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "114": {
                    "column": "fcs_operation_6_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed61\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "115": {
                    "column": "childcare_plan_and_1_other_type",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed61\u7a2e\u985e",
                    "rule": "nullable"
                },
                "116": {
                    "column": "childcare_plan_and_1_other_type_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed61\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "117": {
                    "column": "fcs_operation_id_7",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed62\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "118": {
                    "column": "fcs_operation_7_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed62\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "119": {
                    "column": "childcare_plan_and_2_other_types",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed62\u7a2e\u985e",
                    "rule": "nullable"
                },
                "120": {
                    "column": "childcare_plan_and_2_other_types_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed62\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "121": {
                    "column": "fcs_operation_id_8",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed63\u6642\u671f",
                    "rule": "nullable|integer"
                },
                "122": {
                    "column": "fcs_operation_8_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed63\u6642\u671f\u8868\u793a",
                    "rule": "nullable"
                },
                "123": {
                    "column": "childcare_plan_and_3_other_types",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed63\u7a2e\u985e",
                    "rule": "nullable"
                },
                "124": {
                    "column": "childcare_plan_and_3_other_types_display",
                    "label": "\u4fdd\u80b2\u8a08\u753b\u305d\u306e\u4ed63\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "125": {
                    "column": "production_zoning_division",
                    "label": "\u751f\u7523\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206",
                    "rule": "nullable"
                },
                "126": {
                    "column": "production_zoning_division_display",
                    "label": "\u751f\u7523\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "127": {
                    "column": "public_utility_1_zoning_division",
                    "label": "\u516c\u76ca\uff11\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206",
                    "rule": "nullable"
                },
                "128": {
                    "column": "public_utility_1_zoning_division_display",
                    "label": "\u516c\u76ca\uff11\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "129": {
                    "column": "public_utility_2_zoning_division",
                    "label": "\u516c\u76ca\uff12\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206",
                    "rule": "nullable"
                },
                "130": {
                    "column": "public_utility_2_zoning_division_display",
                    "label": "\u516c\u76ca\uff12\u30be\u30fc\u30cb\u30f3\u30b0\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "131": {
                    "column": "type_of_operation",
                    "label": "\u65bd\u696d\u7a2e",
                    "rule": "nullable"
                },
                "132": {
                    "column": "type_of_operation_display",
                    "label": "\u65bd\u696d\u7a2e\u8868\u793a",
                    "rule": "nullable"
                },
                "133": {
                    "column": "selective_logging_rate",
                    "label": "\u629e\u4f10\u4f10\u63a1\u7387",
                    "rule": "nullable"
                },
                "134": {
                    "column": "wildlife_damage_prevention_category",
                    "label": "\u9ce5\u7363\u5bb3\u9632\u6b62\u533a\u5206",
                    "rule": "nullable"
                },
                "135": {
                    "column": "wildlife_damage_prevention_category_display",
                    "label": "\u9ce5\u7363\u5bb3\u9632\u6b62\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "136": {
                    "column": "road_network_maintenance",
                    "label": "\u8def\u7db2\u6574\u5099\u4e0d\u5b9f\u65bd\u533a\u5206",
                    "rule": "nullable"
                },
                "137": {
                    "column": "road_network_maintenance_display",
                    "label": "\u8def\u7db2\u6574\u5099\u4e0d\u5b9f\u65bd\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "138": {
                    "column": "ownership_category",
                    "label": "\u6240\u6709\u533a\u5206",
                    "rule": "nullable"
                },
                "139": {
                    "column": "ownership_category_display",
                    "label": "\u6240\u6709\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "140": {
                    "column": "forest_reserve",
                    "label": "\u68ee\u6797\u4fdd\u8b77\u533a\u5206",
                    "rule": "nullable"
                },
                "141": {
                    "column": "forest_reserve_display",
                    "label": "\u68ee\u6797\u4fdd\u8b77\u533a\u5206\u8868\u793a",
                    "rule": "nullable"
                },
                "142": {
                    "column": "road_network_maintenance_promotion_area",
                    "label": "\u8def\u7db2\u6574\u5099\u7b49\u63a8\u9032\u30a8\u30ea\u30a2",
                    "rule": "nullable"
                },
                "143": {
                    "column": "road_network_maintenance_promotion_area_display",
                    "label": "\u8def\u7db2\u6574\u5099\u7b49\u63a8\u9032\u30a8\u30ea\u30a2\u8868\u793a",
                    "rule": "nullable"
                },
                "144": {
                    "column": "contractor_refecture",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u90fd\u9053\u5e9c\u770c",
                    "rule": "nullable"
                },
                "145": {
                    "column": "contractor_refecture_display",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u90fd\u9053\u5e9c\u770c\u8868\u793a",
                    "rule": "nullable"
                },
                "146": {
                    "column": "contractor_municipality",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u5e02\u753a\u6751",
                    "rule": "nullable"
                },
                "147": {
                    "column": "contractor_municipality_display",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u5e02\u753a\u6751\u8868\u793a",
                    "rule": "nullable"
                },
                "148": {
                    "column": "contractor_name_kana",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u6c0f\u540d\u30ab\u30bf\u30ab\u30ca",
                    "rule": "nullable"
                },
                "149": {
                    "column": "subcontractor_same_name_category",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u540c\u540d\u533a\u5206",
                    "rule": "nullable"
                },
                "150": {
                    "column": "contractor_ownership",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u6240\u6709\u5f62\u614b",
                    "rule": "nullable"
                },
                "151": {
                    "column": "contractor_ownership_display",
                    "label": "\u53d7\u59d4\u8a17\u5951\u7d04\u8005\u6240\u6709\u5f62\u614b\u8868\u793a",
                    "rule": "nullable"
                },
                "152": {
                    "column": "use_of_forest_environment_tax",
                    "label": "\u68ee\u6797\u74b0\u5883\u7a0e\u4f7f\u9014\u5730",
                    "rule": "nullable"
                },
                "153": {
                    "column": "use_of_forest_environment_tax_display",
                    "label": "\u68ee\u6797\u74b0\u5883\u7a0e\u4f7f\u9014\u5730\u8868\u793a",
                    "rule": "nullable"
                },
                "154": {
                    "column": "mortgage",
                    "label": "\u62b5\u5f53\u6a29",
                    "rule": "nullable"
                },
                "155": {
                    "column": "mortgage_display",
                    "label": "\u62b5\u5f53\u6a29\u8868\u793a",
                    "rule": "nullable"
                },
                "156": {
                    "column": "remark_type",
                    "label": "\u5099\u8003\u7a2e\u985e",
                    "rule": "nullable"
                },
                "157": {
                    "column": "remark_type_display",
                    "label": "\u5099\u8003\u7a2e\u985e\u8868\u793a",
                    "rule": "nullable"
                },
                "158": {
                    "column": "remarks",
                    "label": "\u5099\u8003",
                    "rule": "nullable"
                },
                "159": {
                    "column": "update_year",
                    "label": "\u66f4\u65b0\u5e74",
                    "rule": "nullable"
                },
                "160": {
                    "column": "update_year_display",
                    "label": "\u66f4\u65b0\u5e74\u8868\u793a",
                    "rule": "nullable"
                }
            },
            "IMPORT_CSV_COLUMNS": [
                "fcs_member_id",
                "forest_management_complex_id",
                "data_time",
                "prefecture_id",
                "fcs_yield_table_id",
                "fcs_forest_species_id",
                "fcs_operation_id",
                "city",
                "city_large_letter",
                "house_number",
                "search_address",
                "owner",
                "owner_id",
                "forest_group",
                "small_forest_group",
                "branch_group",
                "compensate_group",
                "area",
                "forest_age",
                "position",
                "tree_height",
                "standard_cutting_age",
                "operation_history_thinning_area",
                "operation_history_thinning_year",
                "another_display_of_the_felling_plan_main_thinning",
                "planned_felling_area",
                "felling_planning_year",
                "update_year"
            ],
            "COMPOSITE_UNIQUE_KEY": [
                "forest_management_complex_id",
                "forest_group",
                "small_forest_group",
                "branch_group",
                "compensate_group",
                "fcs_tree_species_id"
            ]
        },
        "FcsIncomeSetting": {
            "CREDIT_PRICE": {
                "key": "credit_price",
                "text": "\u30af\u30ec\u30b8\u30c3\u30c8\u4fa1\u683c"
            },
            "SETTING_OPTIONS_DEFAULT": [
                {
                    "key": "credit_price",
                    "text": "\u30af\u30ec\u30b8\u30c3\u30c8\u4fa1\u683c"
                }
            ]
        },
        "FcsInitialCostSetting": {
            "FOREST_MANAGEMENT_PLAN_COST": {
                "key": "forest_management_plan_cost",
                "text": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u7b56\u5b9a"
            },
            "FOREST_MEASUREMENT_COST": {
                "key": "forest_measurement_cost",
                "text": "\u68ee\u6797\u8a08\u753b\u8cbb\u7528"
            },
            "VALIDITY_REVIEW_COST": {
                "key": "validity_review_cost",
                "text": "\u59a5\u5f53\u6027\u5be9\u67fb\u8cbb\u7528"
            },
            "OTHER_INITIAL_COSTS": {
                "key": "other_initial_costs",
                "text": "\u305d\u306e\u4ed6\u521d\u671f\u8cbb\u7528"
            },
            "SETTING_OPTIONS_DEFAULT": [
                {
                    "key": "forest_management_plan_cost",
                    "text": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u7b56\u5b9a"
                },
                {
                    "key": "forest_measurement_cost",
                    "text": "\u68ee\u6797\u8a08\u753b\u8cbb\u7528"
                },
                {
                    "key": "validity_review_cost",
                    "text": "\u59a5\u5f53\u6027\u5be9\u67fb\u8cbb\u7528"
                },
                {
                    "key": "other_initial_costs",
                    "text": "\u305d\u306e\u4ed6\u521d\u671f\u8cbb\u7528"
                }
            ]
        },
        "FcsOperation": {
            "OPERATION_AFFORESTATION_PLAN": 1,
            "OPERATION_AFFORESTATION_DONE": 2,
            "OPERATION_SILVICULTURE_PLAN": 3,
            "OPERATION_SILVICULTURE_DONE": 4,
            "OPERATION_THINNING_PLAN": 5,
            "OPERATION_THINNING_DONE": 6,
            "OPERATION_MAIN_CUT": 7,
            "OPERATION_REFORESTATION_PLAN": 8,
            "OPERATION_CREDITED": 9,
            "IMPORT_CSV_COLUMNS": []
        },
        "FcsRunningCostSetting": {
            "MANAGEMENT_COST": {
                "key": "management_cost",
                "text": "\u65bd\u696d\u8cbb\u7528"
            },
            "VERIFICATION_REVIEW_COST": {
                "key": "verification_review_cost",
                "text": "\u691c\u8a3c\u5be9\u67fb\u8cbb\u7528"
            },
            "OTHER_OPERATING_COSTS": {
                "key": "other_operating_costs",
                "text": "\u305d\u306e\u4ed6\u904b\u7528\u8cbb\u7528"
            },
            "SETTING_OPTIONS_DEFAULT": [
                {
                    "key": "management_cost",
                    "text": "\u65bd\u696d\u8cbb\u7528"
                },
                {
                    "key": "verification_review_cost",
                    "text": "\u691c\u8a3c\u5be9\u67fb\u8cbb\u7528"
                },
                {
                    "key": "other_operating_costs",
                    "text": "\u305d\u306e\u4ed6\u904b\u7528\u8cbb\u7528"
                }
            ]
        },
        "FcsSettingsDefaultParameter": {
            "FCS_INITIAL_COST_SETTINGS": 1,
            "FCS_RUNNING_COST_SETTINGS": 2,
            "FCS_INCOME_COST_SETTINGS": 3
        },
        "FcsSimulationCoefSetting": {
            "COEFFICIENT_SETTING_1_VALUE": 1,
            "COEFFICIENT_SETTING_2_VALUE": 2,
            "COEFFICIENT_SETTING_3_VALUE": 3,
            "COEFFICIENT_SETTING_OPTION_1": {
                "value": 1,
                "key": "setting1",
                "text": "\u8a2d\u5b9a1"
            },
            "COEFFICIENT_SETTING_OPTION_2": {
                "value": 2,
                "key": "setting2",
                "text": "\u8a2d\u5b9a2"
            },
            "COEFFICIENT_SETTING_OPTION_3": {
                "value": 3,
                "key": "setting3",
                "text": "\u8a2d\u5b9a3"
            },
            "COEFFICIENT_SETTING_OPTIONS": [
                {
                    "value": 1,
                    "key": "setting1",
                    "text": "\u8a2d\u5b9a1"
                },
                {
                    "value": 2,
                    "key": "setting2",
                    "text": "\u8a2d\u5b9a2"
                },
                {
                    "value": 3,
                    "key": "setting3",
                    "text": "\u8a2d\u5b9a3"
                }
            ]
        },
        "FcsTreeSpecies": {
            "TREE_SPECIES_ID_SUGI": 1,
            "TREE_SPECIES_ID_HINOKI": 2,
            "TREE_SPECIES_ID_SHINYOUZYU_FIRST": 38,
            "TREE_SPECIES_ID_SHINYOUZYU_SECOND": 39,
            "TREE_SPECIES_ID_SHINYOUZYU_THIRD": 40,
            "TREE_SPECIES_ID_KOUYOUZYU_FIRST": 38,
            "TREE_SPECIES_ID_KOUYOUZYU_SECOND": 39,
            "TREE_SPECIES_ID_KOUYOUZYU_THIRD": 40,
            "TREE_SPECIES_COLOR_LIST": {
                "1": "#549a41",
                "2": "#b0d259",
                "38": "#ffcb62",
                "39": "#ffcb62",
                "40": "#ffcb62"
            },
            "TREE_SPECIES_ID_OTHER_KOUYOUZYU_LIST": [
                38,
                39,
                40
            ],
            "PRIORITY_ORDER_TREE_SPECIES": [
                1,
                2,
                38,
                39,
                40
            ],
            "SIMULATION_TARGET_TREE_SPECIES": [
                1,
                2,
                38,
                39,
                40
            ],
            "KOUYOUZYU_LIST": [
                38,
                39,
                40
            ],
            "FIRST_SHINYOUZYU_TARGET_PREFECTURE": [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                9,
                10,
                11,
                15,
                16,
                19,
                20,
                21,
                22
            ],
            "SECOND_SHINYOUZYU_TARGET_PREFECTURE": [
                47
            ],
            "THIRD_SHINYOUZYU_TARGET_PREFECTURE": [
                8,
                12,
                13,
                14,
                17,
                18,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46
            ],
            "FIRST_KOUYOUZYU_TARGET_PREFECTURE": [
                12,
                13,
                39,
                40,
                42,
                46,
                47
            ],
            "SECOND_KOUYOUZYU_TARGET_PREFECTURE": [
                24,
                30,
                41,
                44,
                43,
                45
            ],
            "THIRD_KOUYOUZYU_TARGET_PREFECTURE": [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                25,
                26,
                27,
                28,
                29,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38
            ]
        },
        "FcsUnit": {
            "FCS_UNIT_ID_YEN": 1,
            "FCS_UNIT_ID_YEN_PER_HA": 2,
            "FCS_UNIT_ID_YEN_PER_T_CO2": 3
        },
        "FcsYieldTable": {
            "POSITIONS": [
                {
                    "POSITION": 1,
                    "label": "\u5730\u4f4d1"
                },
                {
                    "POSITION": 2,
                    "label": "\u5730\u4f4d2"
                },
                {
                    "POSITION": 3,
                    "label": "\u5730\u4f4d3"
                },
                {
                    "POSITION": 4,
                    "label": "\u5730\u4f4d4"
                },
                {
                    "POSITION": 5,
                    "label": "\u5730\u4f4d5"
                }
            ],
            "FOREST_AGE_INTERVAL_ONE_YEAR_ID": 1,
            "FOREST_AGE_INTERVAL_ONE_YEAR_NAME": "1\u5e74",
            "FOREST_AGE_INTERVAL_FIVE_YEAR_ID": 5,
            "FOREST_AGE_INTERVAL_FIVE_YEAR_NAME": "5\u5e74",
            "FOREST_AGE_INTERVAL_OPTIONS": [
                {
                    "id": 1,
                    "name": "1\u5e74"
                },
                {
                    "id": 5,
                    "name": "5\u5e74"
                }
            ],
            "COMPLETION_FLG_NOT_DONE": 0,
            "COMPLETION_FLG_DONE": 1,
            "IMPORT_CSV_HEADER_COLUMNS": {
                "1": {
                    "column": "tree_species",
                    "label": "\u6a39\u7a2e",
                    "rule": "required|string"
                },
                "2": {
                    "column": "forest_age",
                    "label": "\u6797\u9f62",
                    "rule": "required|float"
                },
                "3": {
                    "column": "position1",
                    "label": "\u5730\u4f4d1",
                    "rule": "nullable|float"
                },
                "4": {
                    "column": "position2",
                    "label": "\u5730\u4f4d2",
                    "rule": "nullable|float"
                },
                "5": {
                    "column": "position3",
                    "label": "\u5730\u4f4d3",
                    "rule": "nullable|float"
                },
                "6": {
                    "column": "position4",
                    "label": "\u5730\u4f4d4",
                    "rule": "nullable|float"
                },
                "7": {
                    "column": "position5",
                    "label": "\u5730\u4f4d5",
                    "rule": "nullable|float"
                },
                "8": {
                    "column": "position6",
                    "label": "\u5730\u4f4d6",
                    "rule": "nullable|float"
                },
                "9": {
                    "column": "position7",
                    "label": "\u5730\u4f4d7",
                    "rule": "nullable|float"
                },
                "10": {
                    "column": "position8",
                    "label": "\u5730\u4f4d8",
                    "rule": "nullable|float"
                },
                "11": {
                    "column": "position9",
                    "label": "\u5730\u4f4d9",
                    "rule": "nullable|float"
                },
                "12": {
                    "column": "position10",
                    "label": "\u5730\u4f4d10",
                    "rule": "nullable|float"
                }
            }
        }
    },
    "ForestManagementPlan": {
        "TREE_SPECIES_MODE": "tree_species",
        "TREE_SPECIES_LABEL": "\u6a39\u7a2e",
        "TREE_AGES_MODE": "tree_ages",
        "TREE_AGES_LABEL": "\u6797\u9f62",
        "OPERATION_PLANNED_MODE": "operation_planned",
        "OPERATION_PLANNED_LABEL": "\u80b2\u6210\u6797\u30fb\u5929\u7136\u6797",
        "PROJECT_MODE": "project",
        "PROJECT_LABEL": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
        "UNASSIGNED_ID": 0,
        "MAP_FILTER_SELECT_OPTION": [
            {
                "mode": "tree_species",
                "name": "\u6a39\u7a2e"
            },
            {
                "mode": "tree_ages",
                "name": "\u6797\u9f62"
            },
            {
                "mode": "operation_planned",
                "name": "\u80b2\u6210\u6797\u30fb\u5929\u7136\u6797"
            }
        ],
        "TREE_AGE_FIRST_RANGE": "0-9",
        "TREE_AGE_FIRST_KEY": "from_zero_to_nine",
        "TREE_AGE_FIRST_NAME": "0-9\u6b73",
        "TREE_AGE_SECOND_RANGE": "10-29",
        "TREE_AGE_SECOND_KEY": "from_ten_to_twenty_nine",
        "TREE_AGE_SECOND_NAME": "10-29\u6b73",
        "TREE_AGE_THIRD_RANGE": "30-49",
        "TREE_AGE_THIRD_KEY": "from_thirty_to_forty_nine",
        "TREE_AGE_THIRD_NAME": "30-49\u6b73",
        "TREE_AGE_FOURTH_RANGE": "50-69",
        "TREE_AGE_FOURTH_KEY": "from_fifty_to_sixty_nine",
        "TREE_AGE_FOURTH_NAME": "50-69\u6b73",
        "TREE_AGE_FIFTH_RANGE": "70-89",
        "TREE_AGE_FIFTH_KEY": "from_seventy_to_eighty_nine",
        "TREE_AGE_FIFTH_NAME": "70-89\u6b73",
        "TREE_AGE_SIXTH_RANGE": "90-",
        "TREE_AGE_SIXTH_KEY": "from_ninety_and_above",
        "TREE_AGE_SIXTH_NAME": "90\u6b73-",
        "TREE_AGE_CHECKBOX_GROUP": [
            {
                "range": "0-9",
                "color": "#166b2c",
                "name": "0-9\u6b73",
                "key": "from_zero_to_nine"
            },
            {
                "range": "10-29",
                "color": "#8dd97d",
                "name": "10-29\u6b73",
                "key": "from_ten_to_twenty_nine"
            },
            {
                "range": "30-49",
                "color": "#feb73b",
                "name": "30-49\u6b73",
                "key": "from_thirty_to_forty_nine"
            },
            {
                "range": "50-69",
                "color": "#ec703d",
                "name": "50-69\u6b73",
                "key": "from_fifty_to_sixty_nine"
            },
            {
                "range": "70-89",
                "color": "#ff0011",
                "name": "70-89\u6b73",
                "key": "from_seventy_to_eighty_nine"
            },
            {
                "range": "90-",
                "color": "#c3010b",
                "name": "90\u6b73-",
                "key": "from_ninety_and_above"
            }
        ],
        "OPERATION_PLANNED_LABEL_WITH_HISTORY": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u3042\u308a",
        "OPERATION_PLANNED_LABEL_NO_HISTORY_WITH_PLAN": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u306a\u3057\u3001\u65bd\u696d\u4e88\u5b9a\u3042\u308a",
        "OPERATION_PLANNED_LABEL_NO_HISTORY_NO_PLAN": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u306a\u3057\u3001\u65bd\u696d\u4e88\u5b9a\u306a\u3057",
        "OPERATION_PLANNED_LABEL_MAIN_CUT_NO_REFORESTATION": "\u80b2\u6210\u6797 \u4e3b\u4f10\u4e88\u5b9a\u3042\u308a\u3001\u518d\u9020\u6797\u4e88\u5b9a\u306a\u3057",
        "OPERATION_PLANNED_LABEL_MAIN_CUT_WITH_REFORESTATION": "\u80b2\u6210\u6797 \u4e3b\u4f10\u4e88\u5b9a\u3042\u308a\u3001\u518d\u9020\u6797\u4e88\u5b9a\u3042\u308a",
        "OPERATION_PLANNED_LABEL_NATURAL_RESTRICTED": "\u5929\u7136\u751f\u6797 \u5236\u9650\u6797",
        "OPERATION_PLANNED_LABEL_NATURAL_NORMAL": "\u5929\u7136\u751f\u6797 \u666e\u901a\u6797",
        "OPERATION_PLANNED_TYPE_WITH_HISTORY": "with_history",
        "OPERATION_PLANNED_TYPE_NO_HISTORY_WITH_PLAN": "no_history_with_plan",
        "OPERATION_PLANNED_TYPE_NO_HISTORY_NO_PLAN": "no_history_no_plan",
        "OPERATION_PLANNED_TYPE_MAIN_CUT_NO_REFORESTATION": "main_cut_no_reforestation",
        "OPERATION_PLANNED_TYPE_MAIN_CUT_WITH_REFORESTATION": "main_cut_with_reforestation",
        "OPERATION_PLANNED_TYPE_NATURAL_RESTRICTED": "natural_restricted",
        "OPERATION_PLANNED_TYPE_NATURAL_NORMAL": "natural_normal",
        "OPERATION_PLANNED_CHECKBOX_GROUP": [
            {
                "type": "with_history",
                "color": "#FF0000",
                "label": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u3042\u308a",
                "restricted_type": 0,
                "thinning_year": true,
                "childcare_history_year": true,
                "afforestation_plan_year": true
            },
            {
                "type": "no_history_with_plan",
                "color": "#FFA500",
                "label": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u306a\u3057\u3001\u65bd\u696d\u4e88\u5b9a\u3042\u308a",
                "restricted_type": 0,
                "thinning_year": null,
                "cutting_planned_year": true,
                "logging_method": "\u9593\u4f10",
                "childcare_plan_year": true,
                "afforestation_plan_year": true
            },
            {
                "type": "no_history_no_plan",
                "color": "#FFFF00",
                "label": "\u80b2\u6210\u6797 \u65bd\u696d\u5c65\u6b74\u306a\u3057\u3001\u65bd\u696d\u4e88\u5b9a\u306a\u3057",
                "restricted_type": 0,
                "thinning_year": null,
                "main_cutting_year": null,
                "afforestation_history_year": null,
                "childcare_history_year": null,
                "cutting_planned_year": null,
                "afforestation_plan_year": null,
                "childcare_plan_year": null
            },
            {
                "type": "main_cut_no_reforestation",
                "color": "#008000",
                "label": "\u80b2\u6210\u6797 \u4e3b\u4f10\u4e88\u5b9a\u3042\u308a\u3001\u518d\u9020\u6797\u4e88\u5b9a\u306a\u3057",
                "restricted_type": 0,
                "cutting_planned_year": true,
                "logging_method": "\u4e3b\u4f10",
                "afforestation_plan_year": true
            },
            {
                "type": "main_cut_with_reforestation",
                "color": "#0000FF",
                "label": "\u80b2\u6210\u6797 \u4e3b\u4f10\u4e88\u5b9a\u3042\u308a\u3001\u518d\u9020\u6797\u4e88\u5b9a\u3042\u308a",
                "restricted_type": 0,
                "cutting_planned_year": true,
                "logging_method": "\u4e3b\u4f10",
                "afforestation_plan_year": true
            },
            {
                "type": "natural_restricted",
                "color": "#800080",
                "label": "\u5929\u7136\u751f\u6797 \u5236\u9650\u6797",
                "restricted_type": 1,
                "forest_type": "\u5929\u7136\u6797",
                "cutting_planned_year": true,
                "logging_method": "\u4e3b\u4f10",
                "afforestation_plan_year": null
            },
            {
                "type": "natural_normal",
                "color": "#A52A2A",
                "label": "\u5929\u7136\u751f\u6797 \u666e\u901a\u6797",
                "restricted_type": 1,
                "forest_type": null
            }
        ]
    },
    "ForestManagementPlanDetail": {
        "FOREST_TYPE_KEY_ZINKOURIN": 0,
        "FOREST_TYPE_KEY_TENNENRIN": 1,
        "FOREST_TYPE_LABEL_ZINKOURIN": "\u4eba\u5de5\u6797",
        "FOREST_TYPE_LABEL_TENNENRIN": "\u5929\u7136\u6797",
        "FOREST_TYPE_LIST": [
            {
                "key": 0,
                "label": "\u4eba\u5de5\u6797"
            },
            {
                "key": 1,
                "label": "\u5929\u7136\u6797"
            }
        ],
        "RESTRICT_TYPE_KEY_NOT_SEIGENRIN": 0,
        "RESTRICT_TYPE_KEY_SEIGENRIN": 1,
        "RESTRICT_TYPE_LABEL_NOT_SEIGENRIN": "\u666e\u901a\u6797",
        "RESTRICT_TYPE_LABEL_SEIGENRIN": "\u5236\u9650\u6797",
        "RESTRICT_TYPE_LIST": [
            {
                "key": 0,
                "label": "\u666e\u901a\u6797"
            },
            {
                "key": 1,
                "label": "\u5236\u9650\u6797"
            }
        ],
        "LOGGING_METHOD_KEY_KANBATU": 1,
        "LOGGING_METHOD_KEY_SYUBATU": 2,
        "LOGGING_METHOD_LABEL_KANBATU": "\u9593\u4f10",
        "LOGGING_METHOD_LABEL_SYUBATU": "\u4e3b\u4f10",
        "LOGGING_METHOD": [
            {
                "key": 1,
                "label": "\u9593\u4f10"
            },
            {
                "key": 2,
                "label": "\u4e3b\u4f10"
            }
        ],
        "ABSORPTION_BEFORE_TYPE_DEFAULT": 0,
        "ABSORPTION_BEFORE_TYPE_1": 1,
        "ABSORPTION_BEFORE_TYPE_2": 2,
        "ABSORPTION_BEFORE_TYPE_3": 3,
        "ABSORPTION_BEFORE_TYPE_4": 4,
        "ABSORPTION_AFTER_TYPE_DEFAULT": 0,
        "ABSORPTION_AFTER_TYPE_1": 1,
        "ABSORPTION_AFTER_TYPE_2": 2,
        "EMISSION_TYPE_DEFAULT": 0,
        "EMISSION_TYPE_1": 1,
        "YEAR_THRESHOLD": 1990,
        "IMPORT_CSV_HEADER_COLUMNS": {
            "1": {
                "column": "name",
                "label": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b",
                "rule": "nullable|string"
            },
            "2": {
                "column": "forest_group",
                "label": "\u6797\u73ed",
                "rule": "required|string|max:10"
            },
            "3": {
                "column": "small_forest_group",
                "label": "\u5c0f\u73ed",
                "rule": "nullable|string|max:10"
            },
            "4": {
                "column": "compensate_group",
                "label": "\u5c0f\u73ed\u756a\u53f7",
                "rule": "nullable|string"
            },
            "5": {
                "column": "branch_group",
                "label": "\u5c0f\u73ed\u679d\u756a",
                "rule": "nullable|string|max:255"
            },
            "6": {
                "column": "area",
                "label": "\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "7": {
                "column": "tree_species",
                "label": "\u6a39\u7a2e",
                "rule": "nullable|string"
            },
            "8": {
                "column": "forest_age",
                "label": "\u6797\u9f62",
                "rule": "nullable|integer|between:-9999,9999"
            },
            "9": {
                "column": "forest_type",
                "label": "\u4eba\u5de5\u6797\u53c8\u306f\u5929\u7136\u6797\u5225",
                "rule": "required|string|max:10"
            },
            "10": {
                "column": "restricted_type",
                "label": "\u5236\u9650\u6797\u304b\u3069\u3046\u304b",
                "rule": "required|string|max:10"
            },
            "11": {
                "column": "position",
                "label": "\u5730\u4f4d",
                "rule": "required|string"
            },
            "12": {
                "column": "thinning_year",
                "label": "\u9593\u4f10\u5c65\u6b74\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "13": {
                "column": "thinning_area",
                "label": "\u9593\u4f10\u5c65\u6b74\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "14": {
                "column": "main_cutting_year",
                "label": "\u4e3b\u4f10\u5c65\u6b74\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "15": {
                "column": "main_cutting_area",
                "label": "\u4e3b\u4f10\u5c65\u6b74\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "16": {
                "column": "afforestation_history_year",
                "label": "\u9020\u6797\u5c65\u6b74\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "17": {
                "column": "afforestation_history_area",
                "label": "\u9020\u6797\u5c65\u6b74\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "18": {
                "column": "childcare_history_year",
                "label": "\u4fdd\u80b2\u5c65\u6b74\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "19": {
                "column": "childcare_history_area",
                "label": "\u4fdd\u80b2\u5c65\u6b74\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "20": {
                "column": "cutting_planned_year",
                "label": "\u4f10\u63a1\u8a08\u753b\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "21": {
                "column": "logging_method",
                "label": "\u4f10\u63a1\u8a08\u753b\u4e3b\u4f10\u9593\u4f10\u5225",
                "rule": "nullable|string"
            },
            "22": {
                "column": "cutting_planned_area",
                "label": "\u4f10\u63a1\u8a08\u753b\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "23": {
                "column": "afforestation_plan_year",
                "label": "\u9020\u6797\u8a08\u753b\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "24": {
                "column": "afforestation_plan_tree_species",
                "label": "\u9020\u6797\u8a08\u753b\u6a39\u7a2e",
                "rule": "nullable|string"
            },
            "25": {
                "column": "afforestation_plan_area",
                "label": "\u9020\u6797\u8a08\u753b\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "26": {
                "column": "childcare_plan_year",
                "label": "\u4fdd\u80b2\u8a08\u753b\u5e74\u5ea6",
                "rule": "nullable|integer"
            },
            "27": {
                "column": "childcare_plan_area",
                "label": "\u4fdd\u80b2\u8a08\u753b\u9762\u7a4d",
                "rule": "nullable|numeric|regex:\/^\\d+(\\.\\d{1,2})?$\/"
            },
            "28": {
                "column": "prefecture",
                "label": "\u90fd\u9053\u5e9c\u770c",
                "rule": "required|string"
            },
            "29": {
                "column": "city",
                "label": "\u5e02\u753a\u6751\uff08\u90e1\uff09",
                "rule": "required|string"
            },
            "30": {
                "column": "city_large_letter",
                "label": "\u5b57(\u5927\u5b57)",
                "rule": "nullable|string"
            },
            "31": {
                "column": "house_number",
                "label": "\u5730\u756a",
                "rule": "nullable|string"
            },
            "32": {
                "column": "standing_wood_volume",
                "label": "\u7acb\u6728\u6750\u7a4d",
                "rule": "nullable|string"
            }
        },
        "IMPORT_CSV_COLUMNS": [
            "organization_id",
            "yield_table_id",
            "prefecture_id",
            "city",
            "city_large_letter",
            "house_number",
            "forest_group",
            "small_forest_group",
            "branch_group",
            "area",
            "forest_type",
            "restricted_type",
            "tree_species_id",
            "forest_age",
            "position",
            "standing_wood_volume",
            "thinning_area",
            "thinning_year",
            "main_cutting_area",
            "main_cutting_year",
            "afforestation_history_area",
            "afforestation_history_year",
            "childcare_history_area",
            "childcare_history_year",
            "cutting_planned_area",
            "cutting_planned_year",
            "afforestation_plan_area",
            "afforestation_plan_tree_species_id",
            "afforestation_plan_year",
            "childcare_plan_area",
            "childcare_plan_year"
        ],
        "HISTORY_KEY_EXISTS": 1,
        "HISTORY_KEY_EXISTS_LABEL": "\u6709",
        "HISTORY_KEY_NONE": 2,
        "HISTORY_KEY_NONE_LABEL": "\u7121",
        "PLAN_KEY_EXISTS": 1,
        "PLAN_KEY_EXISTS_LABEL": "\u6709",
        "PLAN_KEY_NONE": 2,
        "PLAN_KEY_NONE_LABEL": "\u7121",
        "COMPOSITE_UNIQUE_KEY": [],
        "TENNENRIN_TREATED_AS_IKUSEIRIN_COLUMNS": [
            "thinning_year",
            "thinning_area",
            "main_cutting_year",
            "main_cutting_area",
            "afforestation_history_year",
            "afforestation_history_area",
            "childcare_history_year",
            "childcare_history_area",
            "cutting_planned_year",
            "logging_method",
            "cutting_planned_area",
            "afforestation_plan_year",
            "afforestation_plan_tree_species_id",
            "afforestation_plan_area",
            "childcare_plan_year",
            "childcare_plan_area"
        ],
        "PROJECT_EXECUTION_AREA_ADDED": true,
        "PROJECT_EXECUTION_AREA_ADDED_INT": 1,
        "PROJECT_EXECUTION_AREA_NOT_ADDED": false,
        "PROJECT_EXECUTION_AREA_ADDED_LABEL": "\u8ffd\u52a0\u6e08\u307f",
        "PROJECT_EXECUTION_AREA_NOT_ADDED_LABEL": "\u672a\u8ffd\u52a0"
    },
    "ForestManagementPlanUpdateHistory": {
        "CHANGE_TYPE": 1,
        "UPDATE_TYPE": 2,
        "CHANGE_OR_UPDATE_TYPE": [
            {
                "key": 1,
                "label": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u5909\u66f4"
            },
            {
                "key": 2,
                "label": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u66f4\u65b0"
            }
        ],
        "REGISTRATION_AREA_CHANGE_FLAG": [
            {
                "key": 0,
                "label": "\u5909\u66f4\u306f\u306a\u3044\uff08\u767b\u9332\u9762\u7a4d\u3092\u5168\u3066\u5f15\u304d\u7d99\u3044\u3067\u3044\u308b\uff09"
            },
            {
                "key": 1,
                "label": "\u5909\u66f4\u304c\u3042\u308b\uff08\u767b\u9332\u7bc4\u56f2\u304b\u3089\u9664\u304f\u68ee\u6797\u304c\u3042\u308b\uff09"
            },
            {
                "key": 2,
                "label": "\u5909\u66f4\u304c\u3042\u308b\uff08\u767b\u9332\u7bc4\u56f2\u306b\u8ffd\u52a0\u3059\u308b\u68ee\u6797\u304c\u3042\u308b\uff09"
            },
            {
                "key": 3,
                "label": "\u5909\u66f4\u304c\u3042\u308b(\u767b\u9332\u7bc4\u56f2\u306b\u9664\u5916\u3059\u308b\u68ee\u6797\u3068\u8ffd\u52a0\u3059\u308b\u68ee\u6797\u4e21\u65b9\u3042\u308b\uff09"
            }
        ]
    },
    "ImportBindingSetting": {
        "IMPORT_RULE_IN_MODEL": "model",
        "IMPORT_RULE_IN_SERVICE": "service",
        "DATA_KIND_INLET_RESULT": {
            "key": "inlet_results",
            "label": "\u5165\u5eab\u5b9f\u7e3e",
            "status_path": "\/inlet-results\/import\/status",
            "model": "App\\Models\\InletResult",
            "repository": "App\\Repositories\\Member\\InletResultRepository",
            "service": "App\\Services\\Member\\InletResultService",
            "custom_rule_function": "customRules",
            "prepare_params": "prepareImportInletResultParams",
            "include_member_id": true
        },
        "DATA_KIND_DEPARTURE_RESULT": {
            "key": "departure_results",
            "label": "\u51fa\u5eab\u5b9f\u7e3e",
            "status_path": "\/departure-results\/import\/status",
            "model": "App\\Models\\DepartureResult",
            "repository": "App\\Repositories\\Member\\DepartureResultRepository",
            "service": "App\\Services\\Member\\DepartureResultService",
            "custom_rule_function": "customRules",
            "prepare_params": "prepareImportDepartureResultParams",
            "include_member_id": true
        },
        "DATA_KIND_CENTER_STOCK": {
            "key": "center_stocks",
            "label": "\u5728\u5eab\u60c5\u5831",
            "status_path": "\/center_stocks\/import\/status",
            "model": "App\\Models\\CenterStock",
            "repository": "App\\Repositories\\Member\\CenterStockRepository",
            "service": "App\\Services\\Member\\CenterStockService",
            "prepare_params": "prepareImportCenterStockParams"
        },
        "DATA_KIND_CENTER": {
            "key": "centers",
            "label": "\u62e0\u70b9",
            "status_path": "\/center\/import\/status",
            "model": "App\\Models\\Center",
            "repository": "App\\Repositories\\Member\\CenterRepository",
            "service": "App\\Services\\Member\\CenterService",
            "prepare_params": "prepareImportCenterParams",
            "include_member_id": true
        },
        "DATA_KIND_LIST": [
            {
                "key": "inlet_results",
                "label": "\u5165\u5eab\u5b9f\u7e3e",
                "status_path": "\/inlet-results\/import\/status",
                "model": "App\\Models\\InletResult",
                "repository": "App\\Repositories\\Member\\InletResultRepository",
                "service": "App\\Services\\Member\\InletResultService",
                "custom_rule_function": "customRules",
                "prepare_params": "prepareImportInletResultParams",
                "include_member_id": true
            },
            {
                "key": "departure_results",
                "label": "\u51fa\u5eab\u5b9f\u7e3e",
                "status_path": "\/departure-results\/import\/status",
                "model": "App\\Models\\DepartureResult",
                "repository": "App\\Repositories\\Member\\DepartureResultRepository",
                "service": "App\\Services\\Member\\DepartureResultService",
                "custom_rule_function": "customRules",
                "prepare_params": "prepareImportDepartureResultParams",
                "include_member_id": true
            },
            {
                "key": "center_stocks",
                "label": "\u5728\u5eab\u60c5\u5831",
                "status_path": "\/center_stocks\/import\/status",
                "model": "App\\Models\\CenterStock",
                "repository": "App\\Repositories\\Member\\CenterStockRepository",
                "service": "App\\Services\\Member\\CenterStockService",
                "prepare_params": "prepareImportCenterStockParams"
            },
            {
                "key": "centers",
                "label": "\u62e0\u70b9",
                "status_path": "\/center\/import\/status",
                "model": "App\\Models\\Center",
                "repository": "App\\Repositories\\Member\\CenterRepository",
                "service": "App\\Services\\Member\\CenterService",
                "prepare_params": "prepareImportCenterParams",
                "include_member_id": true
            }
        ],
        "FILE_TYPE_CSV": {
            "key": 1,
            "text": "csv"
        },
        "FILE_TYPE_XLSX": {
            "key": 2,
            "text": "xlsx"
        },
        "FILE_TYPE_LIST": [
            {
                "key": 1,
                "text": "csv"
            },
            {
                "key": 2,
                "text": "xlsx"
            }
        ],
        "ERROR_CANCEL_IMPORT_ALL_DATA": {
            "key": 1,
            "text": "\u30c7\u30fc\u30bf\u5168\u4f53\u306e\u53d6\u8fbc\u307f\u3092\u4e2d\u6b62\u3059\u308b"
        },
        "ERROR_IMPORT_EXCLUDING_ERRORS_LINE": {
            "key": 2,
            "text": "\u30a8\u30e9\u30fc\u884c\u3092\u9664\u304d\u30c7\u30fc\u30bf\u53d6\u8fbc\u307f\u3092\u884c\u3046"
        },
        "ERROR_HANDLING_OPTIONS": [
            {
                "key": 2,
                "text": "\u30a8\u30e9\u30fc\u884c\u3092\u9664\u304d\u30c7\u30fc\u30bf\u53d6\u8fbc\u307f\u3092\u884c\u3046"
            },
            {
                "key": 1,
                "text": "\u30c7\u30fc\u30bf\u5168\u4f53\u306e\u53d6\u8fbc\u307f\u3092\u4e2d\u6b62\u3059\u308b"
            }
        ]
    },
    "IpAddress": {
        "TABLE_NAME": "ip_addresses",
        "PERMISSION_SKIP_TFA": 1
    },
    "MailReplyForm": {
        "FORM_TYPE_CUSTOMER": "customer",
        "FORM_TYPE_BROADCAST": "broadcast"
    },
    "MapboxTileset": {
        "STATUS_NOT_SET": 0,
        "STATUS_PROCESSING": 1,
        "STATUS_COMPLETED": 2,
        "STATUS_ERROR": 99
    },
    "MasterIntensity": {
        "TABLE_NAME": "master_intensities"
    },
    "MasterLumber": {
        "TYPE_SHINYOUZYU": 1,
        "TYPE_KOUYOUZYU": 2
    },
    "MasterMenu": {
        "TABLE_NAME": "master_menus",
        "MENU_FCS_ORGANIZATIONS": "fcs\/organizations",
        "MENU_FCS_YIELD_TABLE": "fcs\/yield_tables",
        "MENU_FCS_FOREST_INFORMATION_LIST": "fcs\/forest_information_list",
        "MENU_FCS_YIELD_TABLED": "fcs\/yield_tables",
        "MENU_FCS_MEMBERS": "fcs\/members",
        "MENU_FCS_SIMULATION_RESULTS": "fcs\/simulation_results",
        "MENU_FCS_APPLICATION_LIST": "fcs\/application_list",
        "MENU_FCS_MANAGE_IMPORT": "fcs\/manage\/import",
        "MENU_FCS_MANAGE_SIMULATION": "fcs\/manage\/simulations",
        "MENU_FCS_PROJECT_LIST": "fcs\/project_list",
        "MENU_FCS_ORGANIZATIONS_LABEL": "\u5951\u7d04\u56e3\u4f53",
        "MENU_FCS_YIELD_TABLE_LABEL": "\u6797\u5206\u53ce\u7a6b\u8868",
        "MENU_FCS_FOREST_INFORMATION_LIST_LABEL": "\u6797\u5730\u60c5\u5831",
        "MENU_FCS_YIELD_TABLED_LABEL": "\u6797\u5206\u53ce\u7a6b\u8868",
        "MENU_FCS_MEMBERS_LABEL": "\u30e1\u30f3\u30d0\u30fc",
        "MENU_FCS_SIMULATION_RESULTS_LABEL": "\u30b7\u30df\u30e5\u30ec\u30fc\u30b7\u30e7\u30f3\u7d50\u679c",
        "MENU_FCS_APPLICATION_LIST_LABEL": "\u767b\u9332\u7533\u8acb\u30ea\u30b9\u30c8",
        "MENU_FCS_MANAGE_IMPORT_LABEL": "\u30c7\u30fc\u30bf\u53d6\u8fbc\u7ba1\u7406",
        "MENU_FCS_MANAGE_SIMULATION_LABEL": "\u30b7\u30df\u30e5\u30ec\u30fc\u30b7\u30e7\u30f3\u8a2d\u5b9a",
        "MENU_FCS_PROJECT_LIST_LABEL": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
        "MENU_LABEL_LIST_BUSINESS": {
            "fcs\/members": "\u30e1\u30f3\u30d0\u30fc",
            "fcs\/forest_information_list": "\u6797\u5730\u60c5\u5831",
            "fcs\/simulation_results": "\u30b7\u30df\u30e5\u30ec\u30fc\u30b7\u30e7\u30f3\u7d50\u679c",
            "fcs\/application_list": "\u767b\u9332\u7533\u8acb\u30ea\u30b9\u30c8",
            "fcs\/manage\/simulations": "\u30b7\u30df\u30e5\u30ec\u30fc\u30b7\u30e7\u30f3\u8a2d\u5b9a",
            "fcs\/manage\/import": "\u30c7\u30fc\u30bf\u53d6\u8fbc\u7ba1\u7406",
            "fcs\/project_list": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
            "fcs\/yield_tables": "\u6797\u5206\u53ce\u7a6b\u8868"
        },
        "MENU_LABEL_LIST_MANAGEMENT": {
            "fcs\/organizations": "\u5951\u7d04\u56e3\u4f53",
            "fcs\/yield_tables": "\u6797\u5206\u53ce\u7a6b\u8868"
        },
        "MENU_FCS_ORGANIZATIONS_ICON": "images\/menu\/fcs\/organization.png",
        "MENU_FCS_YIELD_TABLE_ICON": "images\/menu\/fcs\/forest_information.png",
        "MENU_FCS_FOREST_INFORMATION_LIST_ICON": "images\/menu\/fcs\/forest_information.png",
        "MENU_FCS_YIELD_TABLED_ICON": "images\/menu\/fcs\/yield_tables.png",
        "MENU_FCS_MEMBERS_ICON": "images\/menu\/fcs\/members.png",
        "MENU_FCS_SIMULATION_RESULTS_ICON": "images\/menu\/fcs\/dashboard.png",
        "MENU_FCS_APPLICATION_LIST_ICON": "images\/menu\/fcs\/forest_info_registration.png",
        "MENU_FCS_MANAGE_IMPORT_ICON": "images\/menu\/fcs\/dashboard.png",
        "MENU_FCS_MANAGE_SIMULATION_ICON": "images\/menu\/fcs\/forest_info_registration.png",
        "MENU_ICON_LIST": {
            "fcs\/organizations": "images\/menu\/fcs\/organization.png",
            "fcs\/yield_tables": "images\/menu\/fcs\/yield_tables.png",
            "fcs\/forest_information_list": "images\/menu\/fcs\/forest_information.png",
            "fcs\/members": "images\/menu\/fcs\/members.png",
            "fcs\/simulation_results": "images\/menu\/fcs\/dashboard.png",
            "fcs\/application_list": "images\/menu\/fcs\/forest_info_registration.png",
            "fcs\/manage\/import": "images\/menu\/fcs\/dashboard.png",
            "fcs\/manage\/simulations": "images\/menu\/fcs\/forest_info_registration.png"
        },
        "MENU_HAS_BADGE_LIST": {
            "fcs\/simulation_results": false,
            "fcs\/application_list": false,
            "fcs\/manage\/import": false,
            "fcs\/manage\/simulations": false
        },
        "SIDEBAR_FCS_ORGANIZATIONS_ICON": "fcs\/icon-menu-organization",
        "SIDEBAR_FCS_YIELD_TABLE_ICON": "fcs\/icon-menu-forest-information-list",
        "SIDEBAR_FCS_FOREST_INFORMATION_ICON": "fcs\/icon-menu-forest-information-list",
        "SIDEBAR_FCS_YIELD_TABLED_ICON": "fcs\/icon-menu-forest-information-list",
        "SIDEBAR_FCS_MEMBER_ICON": "fcs\/icon-menu-member",
        "SIDEBAR_FCS_SIMULATION_RESULTS_ICON": "fcs\/icon-menu-simulation-results",
        "SIDEBAR_FCS_APPLICATION_LIST_ICON": "fcs\/icon-menu-application-list",
        "SIDEBAR_FCS_MANAGE_IMPORT_ICON": "fcs\/icon-menu-manage-import",
        "SIDEBAR_FCS_MANAGE_SIMULATION_ICON": "fcs\/icon-menu-manage-simulation",
        "SIDEBAR_FCS_PROJECT_LIST_ICON": "fcs\/icon-menu-project-list",
        "SIDEBAR_ICON_LIST": {
            "fcs\/organizations": "fcs\/icon-menu-organization",
            "fcs\/yield_tables": "fcs\/icon-menu-forest-information-list",
            "fcs\/forest_information_list": "fcs\/icon-menu-forest-information-list",
            "fcs\/members": "fcs\/icon-menu-member",
            "fcs\/simulation_results": "fcs\/icon-menu-simulation-results",
            "fcs\/application_list": "fcs\/icon-menu-application-list",
            "fcs\/manage\/import": "fcs\/icon-menu-manage-import",
            "fcs\/manage\/simulations": "fcs\/icon-menu-manage-simulation",
            "fcs\/project_list": "fcs\/icon-menu-project-list"
        }
    },
    "MasterPrefecture": {
        "TABLE_NAME": "master_prefectures",
        "CONVERT_PREFECTURE_LIST": [
            [
                "\u5317\u6d77\u9053",
                "Hokkaido"
            ],
            [
                "\u9752\u68ee\u770c",
                "Aomori"
            ],
            [
                "\u5ca9\u624b\u770c",
                "Iwate"
            ],
            [
                "\u5bae\u57ce\u770c",
                "Miyagi"
            ],
            [
                "\u79cb\u7530\u770c",
                "Akita"
            ],
            [
                "\u5c71\u5f62\u770c",
                "Yamagata"
            ],
            [
                "\u798f\u5cf6\u770c",
                "Fukushima"
            ],
            [
                "\u8328\u57ce\u770c",
                "Ibaraki"
            ],
            [
                "\u6803\u6728\u770c",
                "Tochigi"
            ],
            [
                "\u7fa4\u99ac\u770c",
                "Gunma"
            ],
            [
                "\u57fc\u7389\u770c",
                "Saitama"
            ],
            [
                "\u5343\u8449\u770c",
                "Chiba"
            ],
            [
                "\u6771\u4eac\u90fd",
                "Tokyo"
            ],
            [
                "\u795e\u5948\u5ddd\u770c",
                "Kanagawa"
            ],
            [
                "\u65b0\u6f5f\u770c",
                "Niigata"
            ],
            [
                "\u5bcc\u5c71\u770c",
                "Toyama"
            ],
            [
                "\u77f3\u5ddd\u770c",
                "Ishikawa"
            ],
            [
                "\u798f\u4e95\u770c",
                "Fukui"
            ],
            [
                "\u5c71\u68a8\u770c",
                "Yamanashi"
            ],
            [
                "\u9577\u91ce\u770c",
                "Nagano"
            ],
            [
                "\u5c90\u961c\u770c",
                "Gifu"
            ],
            [
                "\u9759\u5ca1\u770c",
                "Shizuoka"
            ],
            [
                "\u611b\u77e5\u770c",
                "Aichi"
            ],
            [
                "\u4e09\u91cd\u770c",
                "Mie"
            ],
            [
                "\u6ecb\u8cc0\u770c",
                "Shiga"
            ],
            [
                "\u4eac\u90fd\u5e9c",
                "Kyoto"
            ],
            [
                "\u5927\u962a\u5e9c",
                "Osaka"
            ],
            [
                "\u5175\u5eab\u770c",
                "Hyogo"
            ],
            [
                "\u5948\u826f\u770c",
                "Nara"
            ],
            [
                "\u548c\u6b4c\u5c71\u770c",
                "Wakayama"
            ],
            [
                "\u9ce5\u53d6\u770c",
                "Tottori"
            ],
            [
                "\u5cf6\u6839\u770c",
                "Shimane"
            ],
            [
                "\u5ca1\u5c71\u770c",
                "Okayama"
            ],
            [
                "\u5e83\u5cf6\u770c",
                "Hiroshima"
            ],
            [
                "\u5c71\u53e3\u770c",
                "Yamaguchi"
            ],
            [
                "\u5fb3\u5cf6\u770c",
                "Tokushima"
            ],
            [
                "\u9999\u5ddd\u770c",
                "Kagawa"
            ],
            [
                "\u611b\u5a9b\u770c",
                "Ehime"
            ],
            [
                "\u9ad8\u77e5\u770c",
                "Kochi"
            ],
            [
                "\u798f\u5ca1\u770c",
                "Fukuoka"
            ],
            [
                "\u4f50\u8cc0\u770c",
                "Saga"
            ],
            [
                "\u9577\u5d0e\u770c",
                "Nagasaki"
            ],
            [
                "\u718a\u672c\u770c",
                "Kumamoto"
            ],
            [
                "\u5927\u5206\u770c",
                "Oita"
            ],
            [
                "\u5bae\u5d0e\u770c",
                "Miyazaki"
            ],
            [
                "\u9e7f\u5150\u5cf6\u770c",
                "Kagoshima"
            ],
            [
                "\u6c96\u7e04\u770c",
                "Okinawa"
            ]
        ],
        "PREFECTURE_HOKKAIDO_ID": 1,
        "PREFECTURE_AOMORI_ID": 2,
        "PREFECTURE_IWATE_ID": 3,
        "PREFECTURE_MIYAGI_ID": 4,
        "PREFECTURE_AKITA_ID": 5,
        "PREFECTURE_YAMAGATA_ID": 6,
        "PREFECTURE_FUKUSHIMA_ID": 7,
        "PREFECTURE_IBARAKI_ID": 8,
        "PREFECTURE_TOCHIGI_ID": 9,
        "PREFECTURE_GUNMA_ID": 10,
        "PREFECTURE_SAITAMA_ID": 11,
        "PREFECTURE_CHIBA_ID": 12,
        "PREFECTURE_TOKYO_ID": 13,
        "PREFECTURE_KANAGAWA_ID": 14,
        "PREFECTURE_NIIGATA_ID": 15,
        "PREFECTURE_TOYAMA_ID": 16,
        "PREFECTURE_ISHIKAWA_ID": 17,
        "PREFECTURE_FUKUI_ID": 18,
        "PREFECTURE_YAMANASHI_ID": 19,
        "PREFECTURE_NAGANO_ID": 20,
        "PREFECTURE_GIFU_ID": 21,
        "PREFECTURE_SHIZUOKA_ID": 22,
        "PREFECTURE_AICHI_ID": 23,
        "PREFECTURE_MIE_ID": 24,
        "PREFECTURE_SHIGA_ID": 25,
        "PREFECTURE_KYOTO_ID": 26,
        "PREFECTURE_OSAKA_ID": 27,
        "PREFECTURE_HYOGO_ID": 28,
        "PREFECTURE_NARA_ID": 29,
        "PREFECTURE_WAKAYAMA_ID": 30,
        "PREFECTURE_TOTTORI_ID": 31,
        "PREFECTURE_SHIMANE_ID": 32,
        "PREFECTURE_OKAYAMA_ID": 33,
        "PREFECTURE_HIROSHIMA_ID": 34,
        "PREFECTURE_YAMAGUCHI_ID": 35,
        "PREFECTURE_TOKUSHIMA_ID": 36,
        "PREFECTURE_KAGAWA_ID": 37,
        "PREFECTURE_EHIME_ID": 38,
        "PREFECTURE_KOCHI_ID": 39,
        "PREFECTURE_FUKUOKA_ID": 40,
        "PREFECTURE_SAGA_ID": 41,
        "PREFECTURE_NAGASAKI_ID": 42,
        "PREFECTURE_KUMAMOTO_ID": 43,
        "PREFECTURE_OITA_ID": 44,
        "PREFECTURE_MIYAZAKI_ID": 45,
        "PREFECTURE_KAGOSHIMA_ID": 46,
        "PREFECTURE_OKINAWA_ID": 47,
        "REGION_MAPPING": {
            "\u5317\u6d77\u9053": [
                1
            ],
            "\u6771\u5317": [
                2,
                3,
                4,
                5,
                6,
                7
            ],
            "\u95a2\u6771": [
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            "\u4e2d\u90e8": [
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23
            ],
            "\u8fd1\u757f": [
                24,
                25,
                26,
                27,
                28,
                29,
                30
            ],
            "\u4e2d\u56fd": [
                31,
                32,
                33,
                34,
                35
            ],
            "\u56db\u56fd": [
                36,
                37,
                38,
                39
            ],
            "\u4e5d\u5dde\u30fb\u6c96\u7e04": [
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47
            ]
        }
    },
    "Member": {
        "ROLE_USER": 1,
        "ROLE_OPERATOR": 2,
        "OPERATOR_ORGANIZATION_ID": 0,
        "ROLE_LIST": {
            "1": "\u5951\u7d04\u56e3\u4f53",
            "2": "\u904b\u55b6\u8005"
        }
    },
    "MemberLoginLog": {
        "RESULT_SUCCESS": "success",
        "RESULT_FAILED": "failed"
    },
    "MonitoringPlan": {
        "FOREST_OPERATION_AREA_KEY": 1,
        "FOREST_OPERATION_AREA_LABEL": "\u68ee\u6797\u65bd\u696d\u304c\u5b9f\u65bd\u3055\u308c\u305f\u68ee\u6797\u306e\u9762\u7a4d\uff080.9\u3092\u4e57\u3058\u305f\u5024\uff09",
        "FOREST_OPERATION_STATUS_KEY": 2,
        "FOREST_OPERATION_STATUS_LABEL": "\u68ee\u6797\u306e\u65bd\u696d\u306e\u5b9f\u65bd\u72b6\u6cc1",
        "FOREST_PROTECTION_STATUS_KEY": 3,
        "FOREST_PROTECTION_STATUS_LABEL": "\u68ee\u6797\u306e\u4fdd\u8b77\u306e\u5b9f\u65bd\u72b6\u6cc1",
        "FOREST_PEST_PROTECTION_AREA_KEY": 4,
        "FOREST_PEST_PROTECTION_AREA_LABEL": "\uff08\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632\uff09\u68ee\u6797\u306e\u4fdd\u8b77\u306e\u5b9f\u65bd\u9762\u7a4d\uff080.9\u3092\u4e57\u3058\u305f\u5024\uff09",
        "FIRE_PROTECTION_AREA_KEY": 5,
        "FIRE_PROTECTION_AREA_LABEL": "\uff08\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5\uff09\u68ee\u6797\u306e\u4fdd\u8b77\u306e\u5b9f\u65bd\u9762\u7a4d",
        "FOREST_PROTECTION_STATUS_2_KEY": 6,
        "FOREST_PROTECTION_STATUS_2_LABEL": "\u68ee\u6797\u306e\u4fdd\u8b77\u306e\u5b9f\u65bd\u72b6\u6cc1",
        "TIMBER_LUMBER_OUTPUT_KEY": 7,
        "TIMBER_LUMBER_OUTPUT_LABEL": "\u5f53\u8a72\u5e74\u5ea6\u306e\u6a39\u7a2ej\u306e\u4f10\u63a1\u6728\u6750\u306e\u3046\u3061\u88fd\u6750\u7528\u6750\u306e\u51fa\u8377\u91cf",
        "TIMBER_PLYWOOD_OUTPUT_KEY": 8,
        "TIMBER_PLYWOOD_OUTPUT_LABEL": "\u5f53\u8a72\u5e74\u5ea6\u306e\u4f10\u63a1\u6728\u6750\u306e\u3046\u3061\u5408\u677f\u7528\u6750\u306e\u51fa\u8377\u91cf",
        "TIMBER_RAW_OUTPUT_KEY": 9,
        "TIMBER_RAW_OUTPUT_LABEL": "\u5f53\u8a72\u5e74\u5ea6\u306e\u4f10\u63a1\u6728\u6750\u306e\u3046\u3061\u539f\u6599\u7528\u6750\u306e\u51fa\u8377\u91cf",
        "MAIN_CUTTING_AREA_KEY": 10,
        "MAIN_CUTTING_AREA_LABEL": "\u4e3b\u4f10\u304c\u5b9f\u65bd\u3055\u308c\u305f\u68ee\u6797\u306e\u9762\u7a4d",
        "GROWTH_VOLUME_KEY": 11,
        "GROWTH_VOLUME_LABEL": "\u5358\u4f4d\u9762\u7a4d\u5f53\u305f\u308a\u306e\u5e74\u9593\u5e79\u6750\u7a4d\u6210\u9577\u91cf",
        "GROWTH_VOLUME_CALCULATION_KEY": 12,
        "GROWTH_VOLUME_CALCULATION_LABEL": "\u5358\u4f4d\u9762\u7a4d\u5f53\u305f\u308a\u306e\u5e74\u9593\u5e79\u6750\u7a4d\u6210\u9577\u91cf\uff08\u7b97\u5b9a\u306b\u4f7f\u7528\uff09",
        "GROWTH_VOLUME_CALCULATION_2_KEY": 13,
        "GROWTH_VOLUME_CALCULATION_2_LABEL": "\u68ee\u6797\u7c3f\u304b\u3089\u5f97\u3089\u308c\u305f\u6797\u9f62\u968e\u5c64\u5225\u306e\u5358\u4f4d\u9762\u7a4d\u5f53\u305f\u308a\u5e79\u6750\u7a4d\uff08\u88dc\u6b63\u306b\u4f7f\u7528\uff09",
        "GROWTH_VOLUME_BASIC_SURVEY_KEY": 14,
        "GROWTH_VOLUME_BASIC_SURVEY_LABEL": "\u68ee\u6797\u751f\u614b\u7cfb\u591a\u69d8\u6027\u57fa\u790e\u8abf\u67fb\u304b\u3089\u5f97\u3089\u308c\u305f\u6797\u9f62\u968e\u5c64\u5225\u306e\u5358\u4f4d\u9762\u7a4d\u5f53\u305f\u308a\u5e79\u6750\u7a4d\uff08\u88dc\u6b63\u306b\u4f7f\u7528\uff09",
        "STEM_VOLUME_PER_AREA_KEY": 15,
        "STEM_VOLUME_PER_AREA_LABEL": "\u4e3b\u4f10\u524d\u306e\u968e\u5c64i\u306b\u304a\u3051\u308b\u5358\u4f4d\u9762\u7a4d\u5f53\u305f\u308a\u306e\u5e79\u6750\u7a4d\u91cf",
        "VOLUME_DENSITY_KEY": 16,
        "VOLUME_DENSITY_LABEL": "\u5bb9\u7a4d\u5bc6\u5ea6",
        "EXPANSION_FACTOR_KEY": 17,
        "EXPANSION_FACTOR_LABEL": "\u62e1\u5927\u4fc2\u6570",
        "CARBON_RATIO_KEY": 18,
        "CARBON_RATIO_LABEL": "\u70ad\u7d20\u6bd4\u7387\uff08\u70ad\u7d20\u542b\u6709\u7387\uff09",
        "UNDERGROUND_RATIO_KEY": 19,
        "UNDERGROUND_RATIO_LABEL": "\u5730\u4e0b\u90e8\u7387",
        "SITE_CLASS_KEY": 20,
        "SITE_CLASS_LABEL": "\u5730\u4f4d\u7b49\u306b\u3088\u308b\u968e\u5c64",
        "LUMBER_PROCESSING_YIELD_KEY": 21,
        "LUMBER_PROCESSING_YIELD_LABEL": "\u88fd\u6750\u7528\u6750\u304b\u3089\u88fd\u6750\u3078\u52a0\u5de5\u3059\u308b\u969b\u306e\u52a0\u5de5\u6b69\u7559\u307e\u308a",
        "PLYWOOD_PROCESSING_YIELD_KEY": 22,
        "PLYWOOD_PROCESSING_YIELD_LABEL": "\u5408\u677f\u7528\u6750\u304b\u3089\u5408\u677f\u3078\u52a0\u5de5\u3059\u308b\u969b\u306e\u52a0\u5de5\u6b69\u7559\u307e\u308a",
        "RAW_MATERIAL_CHIP_RATE_KEY": 23,
        "RAW_MATERIAL_CHIP_RATE_LABEL": "\u539f\u6599\u7528\u6750\u306e\u6728\u6750\u30c1\u30c3\u30d7\u5316\u7387",
        "FACTORY_WASTE_CHIP_RATE_KEY": 24,
        "FACTORY_WASTE_CHIP_RATE_LABEL": "\u5de5\u5834\u6b8b\u6750\u306e\u6728\u6750\u30c1\u30c3\u30d7\u5316\u7387",
        "DEMOLITION_MATERIAL_CHIP_RATE_KEY": 25,
        "DEMOLITION_MATERIAL_CHIP_RATE_LABEL": "\u89e3\u4f53\u6750\u306e\u6728\u6750\u30c1\u30c3\u30d7\u5316\u7387",
        "RAW_MATERIAL_CHIP_BOARD_RATE_KEY": 26,
        "RAW_MATERIAL_CHIP_BOARD_RATE_LABEL": "\u539f\u6599\u7528\u6750\u7531\u6765\u306e\u6728\u6750\u30c1\u30c3\u30d7\u306e\u6728\u8cea\u30dc\u30fc\u30c9\u5316\u7387",
        "FACTORY_WASTE_CHIP_BOARD_RATE_KEY": 27,
        "FACTORY_WASTE_CHIP_BOARD_RATE_LABEL": "\u5de5\u5834\u6b8b\u6750\u7531\u6765\u306e\u6728\u6750\u30c1\u30c3\u30d7\u306e\u6728\u8cea\u30dc\u30fc\u30c9\u5316\u7387",
        "DEMOLITION_CHIP_BOARD_RATE_KEY": 28,
        "DEMOLITION_CHIP_BOARD_RATE_LABEL": "\u89e3\u4f53\u6750\u7531\u6765\u306e\u6728\u6750\u30c1\u30c3\u30d7\u306e\u6728\u8cea\u30dc\u30fc\u30c9\u5316\u7387",
        "LUMBER_BUILDING_USAGE_RATIO_KEY": 29,
        "LUMBER_BUILDING_USAGE_RATIO_LABEL": "\u88fd\u6750\u306e\u3046\u3061\u5efa\u7bc9\u7528\u88fd\u6750\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "LUMBER_NON_BUILDING_USAGE_RATIO_KEY": 30,
        "LUMBER_NON_BUILDING_USAGE_RATIO_LABEL": "\u88fd\u6750\u306e\u3046\u3061\u975e\u5efa\u7bc9\u7528\u88fd\u6750\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "PLYWOOD_BUILDING_USAGE_RATIO_KEY": 31,
        "PLYWOOD_BUILDING_USAGE_RATIO_LABEL": "\u5408\u677f\u306e\u3046\u3061\u5efa\u7bc9\u7528\u5408\u677f\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "PLYWOOD_NON_BUILDING_USAGE_RATIO_KEY": 32,
        "PLYWOOD_NON_BUILDING_USAGE_RATIO_LABEL": "\u5408\u677f\u306e\u3046\u3061\u975e\u5efa\u7bc9\u7528\u5408\u677f\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "WOOD_BOARD_BUILDING_USAGE_RATIO_KEY": 33,
        "WOOD_BOARD_BUILDING_USAGE_RATIO_LABEL": "\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u3046\u3061\u5efa\u7bc9\u7528\u6728\u8cea\u30dc\u30fc\u30c9\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "WOOD_BOARD_NON_BUILDING_USAGE_RATIO_KEY": 34,
        "WOOD_BOARD_NON_BUILDING_USAGE_RATIO_LABEL": "\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u3046\u3061\u975e\u5efa\u7bc9\u7528\u6728\u8cea\u30dc\u30fc\u30c9\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u308b\u6bd4\u7387",
        "FINAL_PRODUCT_PROCESSING_YIELD_KEY": 35,
        "FINAL_PRODUCT_PROCESSING_YIELD_LABEL": "\u88fd\u6750\u3001\u5408\u677f\u53ca\u3073\u6728\u8cea\u30dc\u30fc\u30c9\u304b\u3089\u6700\u7d42\u6728\u6750\u88fd\u54c1\u3078\u52a0\u5de5\u3059\u308b\u969b\u306e\u52a0\u5de5\u6b69\u7559\u307e\u308a",
        "WOOD_DENSITY_KEY": 36,
        "WOOD_DENSITY_LABEL": "\u6728\u6750\u306e\u5bc6\u5ea6\uff08\u6c17\u4e7e\u72b6\u614b\u306e\u6750\u7a4d\u306b\u5bfe\u3059\u308b\u5168\u4e7e\u72b6\u614b\u306e\u8cea\u91cf\u306e\u6bd4)",
        "WOOD_CARBON_CONTENT_KEY": 37,
        "WOOD_CARBON_CONTENT_LABEL": "\u6728\u6750\u306e\u70ad\u7d20\u542b\u6709\u7387\uff08\u6728\u6750\u306e\u6c17\u4e7e\u72b6\u614b\u306b\u304a\u3051\u308b\u70ad\u7d20\u542b\u6709\u7387\uff09",
        "BUILDING_WOOD_BOARD_CARBON_CONVERSION_KEY": 38,
        "BUILDING_WOOD_BOARD_CARBON_CONVERSION_LABEL": "\u5efa\u7bc9\u7528\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6750\u7a4d\u306b\u304a\u3051\u308b\u70ad\u7d20\u63db\u7b97\u7387",
        "NON_BUILDING_WOOD_BOARD_CARBON_CONVERSION_KEY": 39,
        "NON_BUILDING_WOOD_BOARD_CARBON_CONVERSION_LABEL": "\u975e\u5efa\u7bc9\u7528\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6750\u7a4d\u306b\u304a\u3051\u308b\u70ad\u7d20\u63db\u7b97\u7387",
        "BUILDING_MATERIAL_PERMANENCE_RATE_KEY": 40,
        "BUILDING_MATERIAL_PERMANENCE_RATE_LABEL": "\u5efa\u7bc9\u7528\u306e\u88fd\u6750\u3001\u5408\u677f\u53ca\u3073\u539f\u6599\u7528\u6750\u30fb\u5de5\u5834\u6b8b\u6750\u7531\u6765\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6c38\u7d9a\u6027\u6b8b\u5b58\u7387",
        "BUILDING_DEMOLITION_BOARD_PERMANENCE_RATE_KEY": 41,
        "BUILDING_DEMOLITION_BOARD_PERMANENCE_RATE_LABEL": "\u5efa\u7bc9\u7528\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u305f\u89e3\u4f53\u6750\u7531\u6765\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6c38\u7d9a\u6027\u6b8b\u5b58\u7387",
        "NON_BUILDING_LUMBER_PERMANENCE_RATE_KEY": 42,
        "NON_BUILDING_LUMBER_PERMANENCE_RATE_LABEL": "\u975e\u5efa\u7bc9\u7528\u88fd\u6750\u306e\u6c38\u7d9a\u6027\u6b8b\u5b58\u7387",
        "NON_BUILDING_MATERIAL_PERMANENCE_RATE_KEY": 43,
        "NON_BUILDING_MATERIAL_PERMANENCE_RATE_LABEL": "\u975e\u5efa\u7bc9\u7528\u306e\u5408\u677f\u53ca\u3073\u539f\u6599\u7528\u6750\u30fb\u5de5\u5834\u6b8b\u6750\u7531\u6765\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6c38\u7d9a\u6027\u6b8b\u5b58\u7387",
        "NON_BUILDING_DEMOLITION_BOARD_PERMANENCE_RATE_KEY": 44,
        "NON_BUILDING_DEMOLITION_BOARD_PERMANENCE_RATE_LABEL": "\u975e\u5efa\u7bc9\u7528\u3068\u3057\u3066\u5229\u7528\u3055\u308c\u305f\u89e3\u4f53\u6750\u7531\u6765\u6728\u8cea\u30dc\u30fc\u30c9\u306e\u6c38\u7d9a\u6027\u6b8b\u5b58\u7387",
        "AREA_FOREST_COMPASS": "1",
        "AREA_FOREST_GNSS": "2",
        "AREA_FOREST_COMPASS_GNSS": "3",
        "AREA_FOREST_OTHER": "4",
        "AREA_FOREST_GIS": "5",
        "AREA_FOREST_COMPASS_GIS": "6",
        "AREA_FOREST_GNSS_GIS": "7",
        "AREA_FOREST_COMPASS_GNSS_GIS": "8",
        "AREA_FOREST_OTHER_GIS": "9",
        "AREA_FOREST_COMPASS_NAME": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09",
        "AREA_FOREST_GNSS_NAME": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09",
        "AREA_FOREST_COMPASS_GNSS_NAME": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09",
        "AREA_FOREST_OTHER_NAME": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09",
        "AREA_FOREST_GIS_NAME": "\u68ee\u6797GIS",
        "AREA_FOREST_COMPASS_GIS_NAME": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
        "AREA_FOREST_GNSS_GIS_NAME": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
        "AREA_FOREST_COMPASS_GNSS_GIS_NAME": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
        "AREA_FOREST_OTHER_GIS_NAME": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
        "AREA_FOREST_OPTIONS": [
            {
                "id": "1",
                "name": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09"
            },
            {
                "id": "2",
                "name": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09"
            },
            {
                "id": "3",
                "name": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09"
            },
            {
                "id": "4",
                "name": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09"
            },
            {
                "id": "5",
                "name": "\u68ee\u6797GIS"
            },
            {
                "id": "6",
                "name": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528"
            },
            {
                "id": "7",
                "name": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528"
            },
            {
                "id": "8",
                "name": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528"
            },
            {
                "id": "9",
                "name": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528"
            }
        ],
        "AREA_FOREST_TYPES": {
            "1": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09",
            "2": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09",
            "3": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09",
            "4": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09",
            "5": "\u68ee\u6797GIS",
            "6": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
            "7": "\u5b9f\u6e2c\uff08GNSS\u6e2c\u91cf\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
            "8": "\u5b9f\u6e2c\uff08\u30b3\u30f3\u30d1\u30b9\u30fbGNSS\u6e2c\u91cf\u4f75\u7528\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528",
            "9": "\u5b9f\u6e2c\uff08\u305d\u306e\u4ed6\uff09\u30fb\u68ee\u6797GIS\u4f75\u7528"
        },
        "STATUS_OF_FOREST_PROTECTION_FIELD": 1,
        "STATUS_OF_FOREST_PROTECTION_AIRCRAFT": 2,
        "STATUS_OF_FOREST_PROTECTION_BOTH": 3,
        "STATUS_OF_FOREST_PROTECTION_FIELD_NAME": "\u5b9f\u8e0f",
        "STATUS_OF_FOREST_PROTECTION_AIRCRAFT_NAME": "\u822a\u7a7a\u6a5f",
        "STATUS_OF_FOREST_PROTECTION_BOTH_NAME": "\u5b9f\u8e0f\u30fb\u822a\u7a7a\u6a5f\u4f75\u7528",
        "STATUS_OF_FOREST_PROTECTION_LIST": [
            {
                "id": 1,
                "name": "\u5b9f\u8e0f"
            },
            {
                "id": 2,
                "name": "\u822a\u7a7a\u6a5f"
            },
            {
                "id": 3,
                "name": "\u5b9f\u8e0f\u30fb\u822a\u7a7a\u6a5f\u4f75\u7528"
            }
        ],
        "STATUS_OF_FOREST_PROTECTION_TYPES": {
            "1": "\u5b9f\u8e0f",
            "2": "\u822a\u7a7a\u6a5f",
            "3": "\u5b9f\u8e0f\u30fb\u822a\u7a7a\u6a5f\u4f75\u7528"
        },
        "SHIPMENT_VOLUME_RECEIPT": 1,
        "SHIPMENT_VOLUME_COC_HISTORY": 2,
        "SHIPMENT_VOLUME_OTHER_DATA": 3,
        "SHIPMENT_VOLUME_CALCULATION": 4,
        "SHIPMENT_VOLUME_RECEIPT_NAME": "\u51fa\u8377\u91cf\u306b\u4fc2\u308b\u4f1d\u7968",
        "SHIPMENT_VOLUME_COC_HISTORY_NAME": "CoC\u68ee\u6797\u8a8d\u8a3c\u6750\u306e\u53d6\u5f15\u5c65\u6b74",
        "SHIPMENT_VOLUME_OTHER_DATA_NAME": "\u305d\u306e\u4ed6\u7528\u9014\u5225\u306e\u51fa\u8377\u91cf\u304c\u78ba\u8a8d\u3067\u304d\u308b\u30c7\u30fc\u30bf",
        "SHIPMENT_VOLUME_CALCULATION_NAME": "\u7b97\u5b9a",
        "SHIPMENT_VOLUME_LIST": [
            {
                "id": 1,
                "name": "\u51fa\u8377\u91cf\u306b\u4fc2\u308b\u4f1d\u7968"
            },
            {
                "id": 2,
                "name": "CoC\u68ee\u6797\u8a8d\u8a3c\u6750\u306e\u53d6\u5f15\u5c65\u6b74"
            },
            {
                "id": 3,
                "name": "\u305d\u306e\u4ed6\u7528\u9014\u5225\u306e\u51fa\u8377\u91cf\u304c\u78ba\u8a8d\u3067\u304d\u308b\u30c7\u30fc\u30bf"
            },
            {
                "id": 4,
                "name": "\u7b97\u5b9a"
            }
        ],
        "SHIPMENT_VOLUME_TYPES": {
            "1": "\u51fa\u8377\u91cf\u306b\u4fc2\u308b\u4f1d\u7968",
            "2": "CoC\u68ee\u6797\u8a8d\u8a3c\u6750\u306e\u53d6\u5f15\u5c65\u6b74",
            "3": "\u305d\u306e\u4ed6\u7528\u9014\u5225\u306e\u51fa\u8377\u91cf\u304c\u78ba\u8a8d\u3067\u304d\u308b\u30c7\u30fc\u30bf",
            "4": "\u7b97\u5b9a"
        },
        "STATUS_OF_FOREST_MANAGEMENT": 1,
        "STATUS_OF_FOREST_MANAGEMENT_NAME": "\u9069\u5207\u306a\u65bd\u696d\u306e\u5b9f\u65bd\u72b6\u6cc1\u3092\u8a3c\u660e\u3059\u308b\u8cc7\u6599",
        "STATUS_OF_FOREST_MANAGEMENT_LIST": [
            {
                "id": 1,
                "name": "\u9069\u5207\u306a\u65bd\u696d\u306e\u5b9f\u65bd\u72b6\u6cc1\u3092\u8a3c\u660e\u3059\u308b\u8cc7\u6599"
            }
        ],
        "STATUS_OF_FOREST_MANAGEMENT_TYPES": {
            "1": "\u9069\u5207\u306a\u65bd\u696d\u306e\u5b9f\u65bd\u72b6\u6cc1\u3092\u8a3c\u660e\u3059\u308b\u8cc7\u6599"
        },
        "FOREST_REGISTER": 1,
        "FOREST_REGISTER_NAME": "\u68ee\u6797\u7c3f",
        "FOREST_REGISTER_LIST": [
            {
                "id": 1,
                "name": "\u68ee\u6797\u7c3f"
            }
        ],
        "FOREST_REGISTER_TYPES": {
            "1": "\u68ee\u6797\u7c3f"
        },
        "DEFAULT_VALUE": 1,
        "DEFAULT_VALUE_NAME": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024",
        "OTHER_DOCUMENT_AND_DATA": 2,
        "OTHER_DOCUMENT_AND_DATA_NAME": "\u305d\u306e\u4ed6\u6587\u732e\u30fb\u8cc7\u6599",
        "MEASURED_VALUE": 3,
        "MEASURED_VALUE_NAME": "\u5b9f\u6e2c\u5024",
        "DEFAULT_VALUE_LIST": [
            {
                "id": 1,
                "name": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024"
            }
        ],
        "DEFAULT_VALUE_TYPES": {
            "1": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024"
        },
        "OTHER_DOCUMENT_AND_DATA_LIST": [
            {
                "id": 1,
                "name": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024"
            },
            {
                "id": 2,
                "name": "\u305d\u306e\u4ed6\u6587\u732e\u30fb\u8cc7\u6599"
            }
        ],
        "OTHER_DOCUMENT_AND_DATA_TYPES": {
            "1": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024",
            "2": "\u305d\u306e\u4ed6\u6587\u732e\u30fb\u8cc7\u6599"
        },
        "MEASURED_VALUE_LIST": [
            {
                "id": 1,
                "name": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024"
            },
            {
                "id": 3,
                "name": "\u5b9f\u6e2c\u5024"
            }
        ],
        "MEASURED_VALUE_TYPES": {
            "1": "\u30c7\u30d5\u30a9\u30eb\u30c8\u5024",
            "3": "\u5b9f\u6e2c\u5024"
        },
        "HARVEST_FORECAST_TABLE": 1,
        "HARVEST_FORECAST_TABLE_NAME": "\u53ce\u7a6b\u4e88\u60f3\u8868\u7b49\uff08\u53ce\u7a6b\u4e88\u60f3\u8868\u3001\u6797\u5206\u53ce\u7a6b\u8868\u3001\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09",
        "SYSTEM_HARVEST_TABLE": 2,
        "SYSTEM_HARVEST_TABLE_NAME": "\u30b7\u30b9\u30c6\u30e0\u53ce\u7a6b\u8868\uff08LYCS\u7b49\uff09",
        "OTHER_LITERATURE": 3,
        "OTHER_LITERATURE_NAME": "\u305d\u306e\u4ed6\u306e\u6587\u732e\u30fb\u8cc7\u6599",
        "HARVEST_FORECAST_TABLE_LIST": [
            {
                "id": 1,
                "name": "\u53ce\u7a6b\u4e88\u60f3\u8868\u7b49\uff08\u53ce\u7a6b\u4e88\u60f3\u8868\u3001\u6797\u5206\u53ce\u7a6b\u8868\u3001\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09"
            },
            {
                "id": 2,
                "name": "\u30b7\u30b9\u30c6\u30e0\u53ce\u7a6b\u8868\uff08LYCS\u7b49\uff09"
            },
            {
                "id": 3,
                "name": "\u305d\u306e\u4ed6\u306e\u6587\u732e\u30fb\u8cc7\u6599"
            }
        ],
        "HARVEST_FORECAST_TABLE_TYPES": {
            "1": "\u53ce\u7a6b\u4e88\u60f3\u8868\u7b49\uff08\u53ce\u7a6b\u4e88\u60f3\u8868\u3001\u6797\u5206\u53ce\u7a6b\u8868\u3001\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09",
            "2": "\u30b7\u30b9\u30c6\u30e0\u53ce\u7a6b\u8868\uff08LYCS\u7b49\uff09",
            "3": "\u305d\u306e\u4ed6\u306e\u6587\u732e\u30fb\u8cc7\u6599"
        },
        "FOREST_BIOLOGICAL_DIVERSE_BASIC_SURVEY": 1,
        "FOREST_BIOLOGICAL_DIVERSE_BASIC_SURVEY_NAME": "\u68ee\u6797\u751f\u614b\u7cfb\u591a\u69d8\u6027\u57fa\u790e\u8abf\u67fb",
        "FOREST_BIOLOGICAL_DIVERSE_BASIC_SURVEY_LIST": [
            {
                "id": 1,
                "name": "\u68ee\u6797\u751f\u614b\u7cfb\u591a\u69d8\u6027\u57fa\u790e\u8abf\u67fb"
            }
        ],
        "FOREST_BIOLOGICAL_DIVERSE_BASIC_SURVEY_TYPES": {
            "1": "\u68ee\u6797\u751f\u614b\u7cfb\u591a\u69d8\u6027\u57fa\u790e\u8abf\u67fb"
        },
        "COUNTY_FOREST_MODEL": 1,
        "COUNTY_FOREST_MODEL_NAME": "\u90fd\u9053\u5e9c\u770c\u304c\u68ee\u6797\u7c3f\u306b\u642d\u8f09\u3057\u3066\u3044\u308b\u68ee\u6797\u306e\u84c4\u7a4d\u306e\u7b97\u5b9a\u306b\u7528\u3044\u3066\u3044\u308b\u30e2\u30c7\u30eb\uff08\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09",
        "COUNTY_FOREST_MODEL_LIST": [
            {
                "id": 1,
                "name": "\u90fd\u9053\u5e9c\u770c\u304c\u68ee\u6797\u7c3f\u306b\u642d\u8f09\u3057\u3066\u3044\u308b\u68ee\u6797\u306e\u84c4\u7a4d\u306e\u7b97\u5b9a\u306b\u7528\u3044\u3066\u3044\u308b\u30e2\u30c7\u30eb\uff08\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09"
            }
        ],
        "COUNTY_FOREST_MODEL_TYPES": {
            "1": "\u90fd\u9053\u5e9c\u770c\u304c\u68ee\u6797\u7c3f\u306b\u642d\u8f09\u3057\u3066\u3044\u308b\u68ee\u6797\u306e\u84c4\u7a4d\u306e\u7b97\u5b9a\u306b\u7528\u3044\u3066\u3044\u308b\u30e2\u30c7\u30eb\uff08\u5e83\u8449\u6a39\u6797\u5206\u53ce\u7a6b\u8868\u3001\u6a19\u6e96\u84c4\u7a4d\u8868\u7b49\uff09"
        }
    },
    "MonitoringPlot": {
        "REPRESENTATIVE_POINT_STATUS_NOT_SELECTED": 0,
        "REPRESENTATIVE_POINT_STATUS_SELECTED": 1,
        "STATUS_TEMPORARY": 1,
        "STATUS_CONFIRMED": 2,
        "MONITORING_METHOD_1_KEY": 1,
        "MONITORING_METHOD_2_KEY": 2,
        "MONITORING_METHOD_3_KEY": 3,
        "MONITORING_METHOD_1_LABEL": "\u5b9f\u8e0f\uff08\u5b9f\u6e2c\u30fb\u30c9\u30ed\u30fc\u30f3\uff09",
        "MONITORING_METHOD_2_LABEL": "\u5b9f\u8e0f\uff08\u5b9f\u6e2c\u30fb\u30c9\u30ed\u30fc\u30f3\u6e2c\u91cf\uff09\u3001\u822a\u7a7a\u6a5f\u4f75\u7528\uff08Coming Soon\uff09",
        "MONITORING_METHOD_3_LABEL": "\u822a\u7a7a\u6a5f",
        "MONITORING_METHOD_OPTIONS": [
            {
                "key": 1,
                "label": "\u5b9f\u8e0f\uff08\u5b9f\u6e2c\u30fb\u30c9\u30ed\u30fc\u30f3\uff09"
            },
            {
                "key": 2,
                "label": "\u5b9f\u8e0f\uff08\u5b9f\u6e2c\u30fb\u30c9\u30ed\u30fc\u30f3\u6e2c\u91cf\uff09\u3001\u822a\u7a7a\u6a5f\u4f75\u7528\uff08Coming Soon\uff09"
            },
            {
                "key": 3,
                "label": "\u822a\u7a7a\u6a5f"
            }
        ],
        "MONITORING_AREA_GROUP_MAX_AREA": 30,
        "MONITORING_PLOT_MIN_AREA": 1,
        "MONITORING_AREA_TYPE_ALL": "all",
        "MONITORING_AREA_TYPE_PART": "part"
    },
    "MonitoringReportDocument": {
        "EXCEL_TEMPLATE": "hokoku_shinrin.xlsx",
        "AUTHENTICATION_APPLICATION_FORM_SHEET": "\u8a8d\u8a3c\u7533\u8acb\u66f8",
        "MONITORING_REPORT_COVER_SHEET": "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5831\u544a\u66f8\u8868\u7d19",
        "PERIOD_APPLY_PROJECT_PLANNING_CHANGE_AUTHORIZATION_SHEET": "\u3010HP\u516c\u958b\u30111-2 \u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u306e\u5909\u66f4\u30fb\u8a8d\u8a3c\u3092\u7533\u8acb\u3059\u308b\u671f\u9593",
        "CREDIT_SUMMARY_SHEET": "\u3010HP\u516c\u958b\u30113-4 \u30af\u30ec\u30b8\u30c3\u30c8\u6982\u8981\u30fb\u767a\u884c\u5185\u5bb9",
        "MONITORING_ACHIEVEMENT_SHEET": "\u3010HP\u516c\u958b\u30115.1\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5b9f\u7e3e\uff08FO-001\uff09",
        "YIELD_TABLE_IKUSEIRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
        "YIELD_TABLE_TENNENRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
        "ABSORPTION_CALCULATION_IKUSEIRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "ABSORPTION_CALCULATION_TENNENRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "EMISSION_CALCULATION_SHEET": "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "HWP_SHEET": "\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "SYUBATU_AND_AFFORESTATION_SHEET": "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "ABSORPTION_FOREST_COMMON": "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "TARGET_MONITORING_REPORT_DOCUMENTS": [
            "\u8a8d\u8a3c\u7533\u8acb\u66f8",
            "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5831\u544a\u66f8\u8868\u7d19",
            "\u3010HP\u516c\u958b\u30111-2 \u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u306e\u5909\u66f4\u30fb\u8a8d\u8a3c\u3092\u7533\u8acb\u3059\u308b\u671f\u9593",
            "\u3010HP\u516c\u958b\u30113-4 \u30af\u30ec\u30b8\u30c3\u30c8\u6982\u8981\u30fb\u767a\u884c\u5185\u5bb9",
            "\u3010HP\u516c\u958b\u30115.1\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5b9f\u7e3e\uff08FO-001\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09"
        ],
        "ALL_MONITORING_REPORT_DOCUMENTS": [
            "\u9805\u76ee\u53d6\u5f97\u30b7\u30fc\u30c8",
            "\u66f4\u65b0\u5c65\u6b74(\u5236\u5ea6\u4e8b\u52d9\u5c40\uff09",
            "\u306f\u3058\u3081\u306b\uff08\u672c\u8cc7\u6599\u306e\u8aac\u660e\uff09",
            "\u8a8d\u8a3c\u7533\u8acb\u66f8",
            "\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5831\u544a\u66f8\u8868\u7d19",
            "\u3010HP\u516c\u958b\u30111-2 \u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u306e\u5909\u66f4\u30fb\u8a8d\u8a3c\u3092\u7533\u8acb\u3059\u308b\u671f\u9593",
            "\u3010HP\u516c\u958b\u30113-4 \u30af\u30ec\u30b8\u30c3\u30c8\u6982\u8981\u30fb\u767a\u884c\u5185\u5bb9",
            "\u3010HP\u516c\u958b\u3011\u5438\u53ce\u6d3b\u52d5\u6570\u3068\u9762\u7a4d\uff08FO-003\u30d7\u30ed\u30b0\u30e9\u30e0\u578b\uff09",
            "\u3010HP\u516c\u958b\u30115.1\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u5b9f\u7e3e\uff08FO-001\uff09",
            "\u3010HP\u516c\u958b\u30115.2\u5438\u53ce\u91cf\u306e\u7b97\u5b9a\u65b9\u6cd5",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8 \uff08001\u3001003\u5171\u901a)",
            "\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5e79\u6750\u7a4d\u91cf\u30b7\u30fc\u30c8_\u80b2\u6210\u6797",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5e79\u6750\u7a4d\u91cf\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5e79\u6750\u7a4d\u91cf\u30b7\u30fc\u30c8 _\u4e3b\u4f10\u7528",
            "\uff08\u8a18\u5165\u4e0d\u8981\uff09\u5e74\u5ea6\u8a08\u7b97\u30b7\u30fc\u30c8",
            "\u3010\u524a\u9664\u4e0d\u53ef\u3011\u30d7\u30eb\u30c0\u30a6\u30f3",
            "\u3010\u524a\u9664\u4e0d\u53ef\u3011\u4e8b\u52d9\u5c40\u8ee2\u8a18\uff08\u8a8d\u59d4\uff09"
        ]
    },
    "OperationLog": {
        "OPERATION_TYPE_CREATE": "create",
        "OPERATION_TYPE_READ": "read",
        "OPERATION_TYPE_UPDATE": "update",
        "OPERATION_TYPE_DELETE": "delete",
        "OPERATED_BY_MEMBER": "member",
        "OPERATED_BY_SYSTEM": "system",
        "TARGET_TYPE_PROFILE": 1,
        "TARGET_TYPE_CUSTOMER": 2,
        "TARGET_TYPE_ATTACHMENT": 6,
        "TARGET_TYPE_MAIL_TEMPLATE": 7,
        "TARGET_TYPE_PARTNER": 8
    },
    "Organization": {
        "OPERATING_ORGANIZATION_ID": 0,
        "STATUS_PENDING": 0,
        "STATUS_ACTIVE": 1,
        "STATUS_COMPLETED": 2,
        "STATUS_LABELS": [
            "\u672a\u5951\u7d04",
            "\u5951\u7d04\u4e2d",
            "\u5951\u7d04\u7d42\u4e86"
        ],
        "STATUS_LIST_WITHOUT_COMPLETED": [
            0,
            1
        ],
        "NAME_MAX_LENGTH": 50,
        "MEMO_MAX_LENGTH": 200
    },
    "Permission": {
        "OPERATIONS_CREATE": 1,
        "OPERATIONS_READ": 2,
        "OPERATIONS_UPDATE": 3,
        "OPERATIONS_DELETE": 4,
        "OPERATIONS_LIST": {
            "create": 1,
            "read": 2,
            "update": 3,
            "delete": 4
        }
    },
    "PlanChangeDocument": {
        "PROJECT_IMPLEMENTER_CHANGE_SHEET": "\u4ee3\u8868\u4ee5\u5916\u306e\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u3082\u3057\u304f\u306f\u30d7\u30ed\u30b0\u30e9\u30e0\u578b\u904b\u55b6\u30fb\u7ba1\u7406\u8005",
        "CERTIFICATION_AUTHORITY_CHANGE_SHEET": "\u8a8d\u8a3c\u6a29\u9650\u4fdd\u6709\u4e3b\u4f53\u5909\u66f4\u5c4a",
        "PLAN_CHANGE_DOCUMENT_SHEET": "\u3010HP\u516c\u958b\u3011\u8a08\u753b\u5909\u66f4\u5c4a",
        "PLAN_CHANGE_DOCUMENT_SHEETS": [
            "\u4ee3\u8868\u4ee5\u5916\u306e\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u3082\u3057\u304f\u306f\u30d7\u30ed\u30b0\u30e9\u30e0\u578b\u904b\u55b6\u30fb\u7ba1\u7406\u8005",
            "\u8a8d\u8a3c\u6a29\u9650\u4fdd\u6709\u4e3b\u4f53\u5909\u66f4\u5c4a",
            "\u3010HP\u516c\u958b\u3011\u8a08\u753b\u5909\u66f4\u5c4a",
            "\u3010HP\u516c\u958b\u30117.\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u8a08\u753b\uff08FO-001\uff09",
            "\u767b\u9332\u7533\u8acb\u66f8",
            "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
            "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u9069\u7528\u6761\u4ef6\uff11\u3078\u306e\u9069\u7528\u3068\u8a08\u753b\u306e\u5909\u9077\uff08FO-001\uff09",
            "\u3010HP\u516c\u958b\u30112.\u9069\u7528\u3059\u308b\u65b9\u6cd5\u8ad6\uff08FO-001\uff09",
            "\u3010HP\u516c\u958b\u30113.\u30c7\u30fc\u30bf\u7ba1\u7406",
            "5.\u8ffd\u52a0\u6027\u306b\u95a2\u3059\u308b\u60c5\u5831",
            "\u3010HP\u516c\u958b\u30114.\u7279\u8a18\u4e8b\u9805",
            "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u3011\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef65\u306b\u4fc2\u308b\u78ba\u8a8d\u66f8",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef66\u306b\u4fc2\u308b\u8a93\u7d04\u66f8"
        ],
        "PROJECT_IMPLEMENTER_CHANG_KEY": "1",
        "PROJECT_IMPLEMENTER_CHANGE_KEY": "2",
        "CERTIFICATION_AUTHORITY_CHANGE_KEY": "3",
        "PLAN_CHANGE_DOCUMENT_KEY": "4",
        "PROJECT_IMPLEMENTER_CHANG_LABEL": "\u4ee3\u8868\u8005\u3001\u62c5\u5f53\u8005\u306e\u5f79\u8077\u3001\u6c0f\u540d\u3001\u9023\u7d61\u5148\u306e\u5909\u66f4",
        "PROJECT_IMPLEMENTER_CHANGE_LABEL": "\u5f62\u5f0f\u7684\u306a\u5909\u66f4\uff1a\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u306e\u793e\u540d\u306e\u5909\u66f4\uff08\u7279\u5b9a\u3057\u305f\u6392\u51fa\u6e90\u306e\u5909\u66f4\u7b49\u3092\u4f34\u3044\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u306e\u5b9f\u614b\u306b\u5f71\u97ff\u3092\u4e0e\u3048\u308b\u3082\u306e\u3092\u9664\u304f\uff09",
        "CERTIFICATION_AUTHORITY_CHANGE_LABEL": "\u5f62\u5f0f\u7684\u306a\u5909\u66f4\uff1a\u30af\u30ec\u30b8\u30c3\u30c8\u53d6\u5f97\u4e88\u5b9a\u8005\u306e\u5909\u66f4",
        "PLAN_CHANGE_DOCUMENT_LABEL": "\u5f62\u5f0f\u7684\u306a\u5909\u66f4\u4ee5\u5916",
        "SPECIFIC_DISCHARGE_PERSON_YES": 1,
        "SPECIFIC_DISCHARGE_PERSON_NO": 0,
        "FIXED_TERM_REPORT_FLG_YES": 1,
        "FIXED_TERM_REPORT_FLG_NO": 0,
        "CHANGE_FLG_YES": 1,
        "CHANGE_FLG_NO": 0,
        "CHANGE_FLG_YES_LABEL": "\u6709",
        "CHANGE_FLG_NO_LABEL": "\u7121"
    },
    "PlanChangeDocumentContent": {
        "PROJECT_CHANGE_TYPE_FORMAL_CHANGE_1": 1,
        "PROJECT_CHANGE_TYPE_FORMAL_CHANGE_2": 2,
        "PROJECT_CHANGE_TYPE_OTHER_THAN_FORMAL_CHANGE": 3,
        "VALIDATION_NECESSITY_TYPE_NECESSARY": 1,
        "VALIDATION_NECESSITY_TYPE_NOT_NECESSARY": 2,
        "APPLICATION_CHANGE_TYPE_FORMAL_CHANGE_1": 1,
        "APPLICATION_CHANGE_TYPE_FORMAL_CHANGE_2": 2,
        "APPLICATION_CHANGE_TYPE_FORMAL_CHANGE_3": 3,
        "APPLICATION_CHANGE_TYPE_OTHER_THAN_FORMAL_CHANGE": 4
    },
    "Project": {
        "PRE_REGISTRATION_STATUS": 0,
        "REGISTERED_STATUS": 1,
        "FINISHED_STATUS": 2,
        "UNCERTIFIED_STATUS": 0,
        "CERTIFIED_STATUS": 1,
        "STATUS_LABELS": [
            "\u672a\u8a8d\u8a3c",
            "\u8a8d\u8a3c\u6e08"
        ],
        "YIELD_TABLE_TYPE_PREFECTURE_KEY": "prefecture",
        "YIELD_TABLE_TYPE_ORGANIZATION_KEY": "organization",
        "YIELD_TABLE_TYPE_PREFECTURE_LABEL": "\u90fd\u9053\u5e9c\u770c\u306e\u6797\u5206\u53ce\u7a6b\u8868",
        "YIELD_TABLE_TYPE_ORGANIZATION_LABEL": "\u56e3\u4f53\u306e\u6797\u5206\u53ce\u7a6b\u8868",
        "YIELD_TABLE_OPTIONS": [
            {
                "key": "prefecture",
                "label": "\u90fd\u9053\u5e9c\u770c\u306e\u6797\u5206\u53ce\u7a6b\u8868"
            },
            {
                "key": "organization",
                "label": "\u56e3\u4f53\u306e\u6797\u5206\u53ce\u7a6b\u8868"
            }
        ],
        "REGISTRATION_PLACE_TYPE_ALL_KEY": "all",
        "REGISTRATION_PLACE_TYPE_PART_KEY": "part",
        "REGISTRATION_PLACE_TYPE_ALL_LABEL": "\u5168\u90e8",
        "REGISTRATION_PLACE_TYPE_PART_LABEL": "\u4e00\u90e8",
        "REGISTRATION_PLACE_TYPE_OPTIONS": [
            {
                "key": "all",
                "label": "\u5168\u90e8"
            },
            {
                "key": "part",
                "label": "\u4e00\u90e8"
            }
        ]
    },
    "ProjectDocument": {
        "EXCEL_TEMPLATE": "keikaku_shinrin_template.xlsx",
        "PROJECT_OVERVIEW_SHEET": "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
        "YIELD_TABLE_IKUSEIRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
        "YIELD_TABLE_TENNENRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
        "ABSORPTION_CALCULATION_IKUSEIRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "ABSORPTION_CALCULATION_TENNENRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "EMISSION_CALCULATION_SHEET": "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "HWP_SHEET": "\u3010\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u3011\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "SYUBATU_AND_AFFORESTATION_SHEET": "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "AUTOMATIC_ABSORPTION_CALCULATION_SHEET": "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "CONFIRMATION_OF_APPLICATION_CONDITION_5_SHEET": "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef65\u306b\u4fc2\u308b\u78ba\u8a8d\u66f8",
        "CONFIRMATION_OF_APPLICATION_CONDITION_6_SHEET": "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef66\u306b\u4fc2\u308b\u8a93\u7d04\u66f8",
        "APPLICATION_SHEET_FORMATS": [
            "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u3011\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef65\u306b\u4fc2\u308b\u78ba\u8a8d\u66f8",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef66\u306b\u4fc2\u308b\u8a93\u7d04\u66f8"
        ],
        "FOREST_AGE_INTERVAL_ONE_YEAR_EXCEL_COLUMN_INDEX": {
            "1": "B",
            "2": "F",
            "3": "J",
            "4": "N",
            "5": "R",
            "6": "V",
            "7": "Z",
            "8": "AD",
            "9": "AH",
            "10": "AL",
            "11": "AP",
            "12": "AT",
            "13": "AX",
            "14": "BB",
            "15": "BF",
            "16": "BJ",
            "17": "BN",
            "18": "BR",
            "19": "BV",
            "20": "BZ",
            "21": "CD",
            "22": "CH",
            "23": "CL",
            "24": "CP",
            "25": "CT",
            "26": "CX",
            "27": "DB",
            "28": "DF",
            "29": "DJ",
            "30": "DN",
            "31": "DR",
            "32": "DV",
            "33": "DZ",
            "34": "ED",
            "35": "EH",
            "36": "EL",
            "37": "EP",
            "38": "ET",
            "39": "EX",
            "40": "FB"
        },
        "FOREST_AGE_INTERVAL_TEN_YEAR_EXCEL_COLUMN_INDEX": {
            "1": "D",
            "2": "H",
            "3": "L",
            "4": "P",
            "5": "T",
            "6": "X",
            "7": "AB",
            "8": "AF",
            "9": "AJ",
            "10": "AN",
            "11": "AR",
            "12": "AV",
            "13": "AZ",
            "14": "BD",
            "15": "BH",
            "16": "BL",
            "17": "BP",
            "18": "BT",
            "19": "BX",
            "20": "CB",
            "21": "CF",
            "22": "CJ",
            "23": "CR",
            "24": "CV",
            "25": "CZ",
            "26": "DD",
            "27": "DH",
            "28": "DL",
            "29": "DP",
            "30": "DT",
            "31": "DX",
            "32": "EB",
            "33": "ED",
            "34": "EH",
            "35": "EL",
            "36": "EP",
            "37": "ET",
            "38": "EX",
            "39": "FB",
            "40": "FD"
        },
        "FOREST_AGE_INTERVAL_MARK": "\u25cb"
    },
    "ProjectPlanSubmissionDocument": {
        "APPLICATION_TYPE_PROJECT_REGISTRATION": 1,
        "APPLICATION_TYPE_PROJECT_PLAN_CHANGE": 2,
        "APPLICATION_TYPE_CERTIFICATION_AUTHORITY_CHANGE": 3,
        "APPLICATION_TYPE_PROJECT_REGISTRATION_LABEL": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u767b\u9332",
        "APPLICATION_TYPE_PROJECT_PLAN_CHANGE_LABEL": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u5909\u66f4",
        "APPLICATION_TYPE_CERTIFICATION_AUTHORITY_CHANGE_LABEL": "\u8a8d\u8a3c\u6a29\u9650\u4fdd\u6709\u4e3b\u4f53\u5909\u66f4",
        "APPLICATION_TYPE_OPTIONS": [
            {
                "key": 1,
                "label": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u767b\u9332"
            },
            {
                "key": 2,
                "label": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u5909\u66f4"
            },
            {
                "key": 3,
                "label": "\u8a8d\u8a3c\u6a29\u9650\u4fdd\u6709\u4e3b\u4f53\u5909\u66f4"
            }
        ],
        "REVIEW_SUPPORT_FLAG_NONE": false,
        "REVIEW_SUPPORT_FLAG_YES": true,
        "REVIEW_SUPPORT_FLAG_NONE_LABEL": "\u7121",
        "REVIEW_SUPPORT_FLAG_YES_LABEL": "\u6709",
        "REVIEW_SUPPORT_OPTIONS": [
            {
                "key": false,
                "label": "\u7121"
            },
            {
                "key": true,
                "label": "\u6709"
            }
        ],
        "CHANGED_FLAG_NONE": false,
        "CHANGED_FLAG_YES": true,
        "CHANGED_FLAG_NONE_LABEL": "\u7121",
        "CHANGED_FLAG_YES_LABEL": "\u6709",
        "CHANGED_FLAG_OPTIONS": [
            {
                "key": false,
                "label": "\u7121"
            },
            {
                "key": true,
                "label": "\u6709"
            }
        ],
        "GLOBAL_WARMING_REPORTING_FLAG_NONE": false,
        "GLOBAL_WARMING_REPORTING_FLAG_YES": true,
        "GLOBAL_WARMING_REPORTING_FLAG_NONE_LABEL": " ",
        "GLOBAL_WARMING_REPORTING_FLAG_YES_LABEL": "\u3007",
        "GLOBAL_WARMING_REPORTING_FLAG_YES_OPTIONS": [
            {
                "key": false,
                "label": " "
            },
            {
                "key": true,
                "label": "\u3007"
            }
        ],
        "GLOBAL_WARMING_REPORTING_FLAG_NONE_OPTIONS": [
            {
                "key": false,
                "label": "\u3007"
            },
            {
                "key": true,
                "label": " "
            }
        ],
        "ENERGY_EFFICIENCY_REPORTING_FLAG_NONE": false,
        "ENERGY_EFFICIENCY_REPORTING_FLAG_YES": true,
        "ENERGY_EFFICIENCY_REPORTING_FLAG_NONE_LABEL": " ",
        "ENERGY_EFFICIENCY_REPORTING_FLAG_YES_LABEL": "\u3007",
        "ENERGY_EFFICIENCY_REPORTING_FLAG_YES_OPTIONS": [
            {
                "key": false,
                "label": " "
            },
            {
                "key": true,
                "label": "\u3007"
            }
        ],
        "ENERGY_EFFICIENCY_REPORTING_FLAG_NONE_OPTIONS": [
            {
                "key": false,
                "label": "\u3007"
            },
            {
                "key": true,
                "label": " "
            }
        ],
        "VALIDITY_REVIEW_ORGANIZATION_JMA": "\u4e00\u822c\u793e\u56e3\u6cd5\u4eba \u65e5\u672c\u80fd\u7387\u5354\u4f1a",
        "VALIDITY_REVIEW_ORGANIZATION_JQA": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u54c1\u8cea\u4fdd\u8a3c\u6a5f\u69cb",
        "VALIDITY_REVIEW_ORGANIZATION_CLASS_NK": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u6d77\u4e8b\u5354\u4f1a",
        "VALIDITY_REVIEW_ORGANIZATION_SOCOTEC": "\u30bd\u30b3\u30c6\u30c3\u30af\u30fb\u30b5\u30fc\u30c6\u30a3\u30d5\u30a3\u30b1\u30fc\u30b7\u30e7\u30f3\u30fb\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e",
        "VALIDITY_REVIEW_ORGANIZATION_MOE": "\u74b0\u5883\u7701(\u30c0\u30df\u30fc\u306e\u5be9\u67fb\u6a5f\u95a2)",
        "VALIDITY_REVIEW_ORGANIZATION_TECO": "\u682a\u5f0f\u4f1a\u793e\u30c8\u30fc\u30de\u30c4\u5be9\u67fb\u8a55\u4fa1\u6a5f\u69cb",
        "VALIDITY_REVIEW_ORGANIZATION_NKKQA": "\u65e5\u672c\u6d77\u4e8b\u691c\u5b9a\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e",
        "VALIDITY_REVIEW_ORGANIZATION_JACO": "\u682a\u5f0f\u4f1a\u793e JACO CDM",
        "VALIDITY_REVIEW_ORGANIZATION_LRQA": "\u30ed\u30a4\u30c9 \u30ec\u30b8\u30b9\u30bf\u30fc \u30af\u30aa\u30ea\u30c6\u30a3 \u30a2\u30b7\u30e5\u30a2\u30e9\u30f3\u30b9 \u30ea\u30df\u30c6\u30c3\u30c9\u30b8\u30e3\u30d1\u30f3",
        "VALIDITY_REVIEW_ORGANIZATION_SGS": "SGS \u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u8a8d\u8a3c\u30b5\u30fc\u30d3\u30b9\u4e8b\u696d\u90e8",
        "VALIDITY_REVIEW_ORGANIZATION_BV": "\u30d3\u30e5\u30fc\u30ed\u30fc\u30d9\u30ea\u30bf\u30b9\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u30b7\u30b9\u30c6\u30e0\u8a8d\u8a3c\u4e8b\u696d\u672c\u90e8",
        "VALIDITY_REVIEW_ORGANIZATION_JICQA": "\u65e5\u672c\u691c\u67fb\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e",
        "VALIDITY_REVIEW_ORGANIZATION_JSECO": "\u682a\u5f0f\u4f1a\u793e\u65e5\u672c\u30b9\u30de\u30fc\u30c8\u30a8\u30ca\u30b8\u30fc\u8a8d\u8a3c\u6a5f\u69cb",
        "VALIDITY_REVIEW_ORGANIZATION_OPTIONS": [
            {
                "key": "\u4e00\u822c\u793e\u56e3\u6cd5\u4eba \u65e5\u672c\u80fd\u7387\u5354\u4f1a",
                "label": "\u4e00\u822c\u793e\u56e3\u6cd5\u4eba \u65e5\u672c\u80fd\u7387\u5354\u4f1a"
            },
            {
                "key": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u54c1\u8cea\u4fdd\u8a3c\u6a5f\u69cb",
                "label": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u54c1\u8cea\u4fdd\u8a3c\u6a5f\u69cb"
            },
            {
                "key": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u6d77\u4e8b\u5354\u4f1a",
                "label": "\u4e00\u822c\u8ca1\u56e3\u6cd5\u4eba \u65e5\u672c\u6d77\u4e8b\u5354\u4f1a"
            },
            {
                "key": "\u30bd\u30b3\u30c6\u30c3\u30af\u30fb\u30b5\u30fc\u30c6\u30a3\u30d5\u30a3\u30b1\u30fc\u30b7\u30e7\u30f3\u30fb\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e",
                "label": "\u30bd\u30b3\u30c6\u30c3\u30af\u30fb\u30b5\u30fc\u30c6\u30a3\u30d5\u30a3\u30b1\u30fc\u30b7\u30e7\u30f3\u30fb\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e"
            },
            {
                "key": "\u74b0\u5883\u7701(\u30c0\u30df\u30fc\u306e\u5be9\u67fb\u6a5f\u95a2)",
                "label": "\u74b0\u5883\u7701(\u30c0\u30df\u30fc\u306e\u5be9\u67fb\u6a5f\u95a2)"
            },
            {
                "key": "\u682a\u5f0f\u4f1a\u793e\u30c8\u30fc\u30de\u30c4\u5be9\u67fb\u8a55\u4fa1\u6a5f\u69cb",
                "label": "\u682a\u5f0f\u4f1a\u793e\u30c8\u30fc\u30de\u30c4\u5be9\u67fb\u8a55\u4fa1\u6a5f\u69cb"
            },
            {
                "key": "\u65e5\u672c\u6d77\u4e8b\u691c\u5b9a\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e",
                "label": "\u65e5\u672c\u6d77\u4e8b\u691c\u5b9a\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e"
            },
            {
                "key": "\u682a\u5f0f\u4f1a\u793e JACO CDM",
                "label": "\u682a\u5f0f\u4f1a\u793e JACO CDM"
            },
            {
                "key": "\u30ed\u30a4\u30c9 \u30ec\u30b8\u30b9\u30bf\u30fc \u30af\u30aa\u30ea\u30c6\u30a3 \u30a2\u30b7\u30e5\u30a2\u30e9\u30f3\u30b9 \u30ea\u30df\u30c6\u30c3\u30c9\u30b8\u30e3\u30d1\u30f3",
                "label": "\u30ed\u30a4\u30c9 \u30ec\u30b8\u30b9\u30bf\u30fc \u30af\u30aa\u30ea\u30c6\u30a3 \u30a2\u30b7\u30e5\u30a2\u30e9\u30f3\u30b9 \u30ea\u30df\u30c6\u30c3\u30c9\u30b8\u30e3\u30d1\u30f3"
            },
            {
                "key": "SGS \u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u8a8d\u8a3c\u30b5\u30fc\u30d3\u30b9\u4e8b\u696d\u90e8",
                "label": "SGS \u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u8a8d\u8a3c\u30b5\u30fc\u30d3\u30b9\u4e8b\u696d\u90e8"
            },
            {
                "key": "\u30d3\u30e5\u30fc\u30ed\u30fc\u30d9\u30ea\u30bf\u30b9\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u30b7\u30b9\u30c6\u30e0\u8a8d\u8a3c\u4e8b\u696d\u672c\u90e8",
                "label": "\u30d3\u30e5\u30fc\u30ed\u30fc\u30d9\u30ea\u30bf\u30b9\u30b8\u30e3\u30d1\u30f3\u682a\u5f0f\u4f1a\u793e \u30b7\u30b9\u30c6\u30e0\u8a8d\u8a3c\u4e8b\u696d\u672c\u90e8"
            },
            {
                "key": "\u65e5\u672c\u691c\u67fb\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e",
                "label": "\u65e5\u672c\u691c\u67fb\u30ad\u30e5\u30fc\u30a8\u30a4\u682a\u5f0f\u4f1a\u793e"
            },
            {
                "key": "\u682a\u5f0f\u4f1a\u793e\u65e5\u672c\u30b9\u30de\u30fc\u30c8\u30a8\u30ca\u30b8\u30fc\u8a8d\u8a3c\u6a5f\u69cb",
                "label": "\u682a\u5f0f\u4f1a\u793e\u65e5\u672c\u30b9\u30de\u30fc\u30c8\u30a8\u30ca\u30b8\u30fc\u8a8d\u8a3c\u6a5f\u69cb"
            }
        ],
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_1": "\u2460\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_2": "\u2461\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_3": "\u2462\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u306b\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3057\u3066\u3044\u308b\u68ee\u6797\u3068\u7ba1\u7406\u3057\u3066\u3044\u308b\u68ee\u6797\u3069\u3061\u3089\u3082\u3042\u308a\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_4": "\u2463\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_5": "\u2464\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_6": "\u2465\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_7": "\u2466\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_8": "\u2467\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_9": "\u2468\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
        "PROJECT_FOREST_SCOPE_AND_ATTRIBUTES_OPTIONS": [
            {
                "key": "\u2460\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
                "label": "\u2460\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2461\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
                "label": "\u2461\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u3092\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2462\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u306b\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3057\u3066\u3044\u308b\u68ee\u6797\u3068\u7ba1\u7406\u3057\u3066\u3044\u308b\u68ee\u6797\u3069\u3061\u3089\u3082\u3042\u308a\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09",
                "label": "\u2462\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u533a\u57df\u5168\u4f53\uff08\u5f53\u8a72\u68ee\u6797\u306b\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3057\u3066\u3044\u308b\u68ee\u6797\u3068\u7ba1\u7406\u3057\u3066\u3044\u308b\u68ee\u6797\u3069\u3061\u3089\u3082\u3042\u308a\u3001\u9069\u7528\u6761\u4ef61-1\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2463\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
                "label": "\u2463\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2464\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
                "label": "\u2464\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2465\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09",
                "label": "\u2465\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u306e\u307f\uff08\u305d\u306e\u533a\u57df\u5168\u4f53\u3001\u9069\u7528\u6761\u4ef61-2\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2466\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
                "label": "\u2466\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2467\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
                "label": "\u2467\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u7ba1\u7406\u3059\u308b\u68ee\u6797\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09"
            },
            {
                "key": "\u2468\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09",
                "label": "\u2468\u6240\u5b9a\u306e\u8981\u4ef6\u3092\u5168\u3066\u6e80\u305f\u3057\u305f\u4e0a\u3067\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u5b9f\u65bd\u3057\u3088\u3046\u3068\u3059\u308b\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u3046\u3061\u3001\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u81ea\u3089\u304c\u6240\u6709\u53ca\u3073\u7ba1\u7406\u3059\u308b\u68ee\u6797\uff08\u3069\u3061\u3089\u3082\u3042\u308a\uff09\u304b\u3089\u4e00\u90e8\u62bd\u51fa\u3057\u305f\u68ee\u6797(\u9069\u7528\u6761\u4ef61-3\u306b\u8a72\u5f53\uff09"
            }
        ],
        "ABSORPTION_ACTIVITY_TYPE_NORMAL": "\u901a\u5e38\u306e\u80b2\u6210\u6797\u30fb\u5929\u7136\u751f\u6797\u306e\u5438\u53ce\u91cf\u306e\u307f",
        "ABSORPTION_ACTIVITY_TYPE_NORMAL_AND_HARVESTED": "\u901a\u5e38\u306e\u5438\u53ce\u91cf\uff0b\u4f10\u63a1\u6728\u6750\u306b\u4fc2\u308b\u5438\u53ce\u91cf",
        "ABSORPTION_ACTIVITY_TYPE_NORMAL_OPTIONS": [
            {
                "key": "\u901a\u5e38\u306e\u80b2\u6210\u6797\u30fb\u5929\u7136\u751f\u6797\u306e\u5438\u53ce\u91cf\u306e\u307f",
                "label": "\u3007"
            },
            {
                "key": "\u901a\u5e38\u306e\u5438\u53ce\u91cf\uff0b\u4f10\u63a1\u6728\u6750\u306b\u4fc2\u308b\u5438\u53ce\u91cf",
                "label": ""
            }
        ],
        "ABSORPTION_ACTIVITY_TYPE_NORMAL_AND_HARVESTED_OPTIONS": [
            {
                "key": "\u901a\u5e38\u306e\u80b2\u6210\u6797\u30fb\u5929\u7136\u751f\u6797\u306e\u5438\u53ce\u91cf\u306e\u307f",
                "label": ""
            },
            {
                "key": "\u901a\u5e38\u306e\u5438\u53ce\u91cf\uff0b\u4f10\u63a1\u6728\u6750\u306b\u4fc2\u308b\u5438\u53ce\u91cf",
                "label": "\u3007"
            }
        ],
        "HAS_REFORESTATION_PLAN": true,
        "NO_REFORESTATION_PLAN": false,
        "REFORESTATION_PLAN_OPTIONS": [
            {
                "key": true,
                "label": "\u3042\u308a"
            },
            {
                "key": false,
                "label": "\u306a\u3057"
            }
        ],
        "REGISTRATION_TYPE_NEW": 1,
        "REGISTRATION_TYPE_J_VER": 2,
        "REGISTRATION_TYPE_OPTIONS": [
            {
                "key": 2,
                "label": ""
            },
            {
                "key": 1,
                "label": "\u3007"
            }
        ],
        "REGISTRATION_TYPE_J_VER_OPTIONS": [
            {
                "key": 1,
                "label": ""
            },
            {
                "key": 2,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_EVALUATION_TYPE_1": 1,
        "ADDITIVITY_EVALUATION_TYPE_2": 2,
        "ADDITIVITY_EVALUATION_TYPE_3": 3,
        "ADDITIVITY_EVALUATION_TYPE_OPTIONS_1": [
            {
                "key": "",
                "label": ""
            },
            {
                "key": 1,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_EVALUATION_TYPE_OPTIONS_2": [
            {
                "key": "",
                "label": ""
            },
            {
                "key": 2,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_EVALUATION_TYPE_OPTIONS_3": [
            {
                "key": "",
                "label": ""
            },
            {
                "key": 3,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_RESULT_NONE": 1,
        "ADDITIVITY_RESULT_NEED": 2,
        "ADDITIVITY_RESULT_NONE_OPTIONS": [
            {
                "key": 2,
                "label": ""
            },
            {
                "key": 1,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_RESULT_NEED_OPTIONS": [
            {
                "key": 1,
                "label": ""
            },
            {
                "key": 2,
                "label": "\u3007"
            }
        ],
        "ADDITIVITY_EVALUATION_RESULT_OPTIONS": [
            {
                "value": "\u8ffd\u52a0\u6027\u3042\u308a",
                "label": "\u8ffd\u52a0\u6027\u3042\u308a"
            },
            {
                "value": "\u8ffd\u52a0\u6027\u306a\u3057",
                "label": "\u8ffd\u52a0\u6027\u306a\u3057"
            }
        ],
        "J_CREDIT_HOLDER_NOT_DETERMINED": 1,
        "J_CREDIT_HOLDER_DETERMINED": 2,
        "J_CREDIT_HOLDER_NOT_DETERMINED_OPTIONS": [
            {
                "key": 2,
                "label": ""
            },
            {
                "key": 1,
                "label": "\u3007"
            }
        ],
        "EXCEL_TEMPLATE": "keikaku_shinrin_template.xlsx",
        "REGISTRATION_APPLICATION_SHEET": "\u767b\u9332\u7533\u8acb\u66f8",
        "PROJECT_PLAN_COVER_SHEET": "\u3010HP\u516c\u958b\u3011\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u66f8\u8868\u7d19",
        "PROJECT_OVERVIEW_SHEET": "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
        "TRANSITION_OF_APPLYING_AND_PLANS_SHEET": "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u9069\u7528\u6761\u4ef6\uff11\u3078\u306e\u9069\u7528\u3068\u8a08\u753b\u306e\u5909\u9077\uff08FO-001\uff09",
        "APPLY_METHODOLOGY_SHEET": "\u3010HP\u516c\u958b\u30112.\u9069\u7528\u3059\u308b\u65b9\u6cd5\u8ad6\uff08FO-001\uff09",
        "DATA_MANAGEMENT_SHEET": "\u3010HP\u516c\u958b\u30113.\u30c7\u30fc\u30bf\u7ba1\u7406",
        "ADDITIONAL_INFORMATION_SHEET": "5.\u8ffd\u52a0\u6027\u306b\u95a2\u3059\u308b\u60c5\u5831",
        "SPECIAL_NOTES_SHEET": "\u3010HP\u516c\u958b\u30114.\u7279\u8a18\u4e8b\u9805",
        "MONITORING_PLAN_SHEET": "\u3010HP\u516c\u958b\u30117.\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u8a08\u753b\uff08FO-001\uff09",
        "YIELD_TABLE_IKUSEIRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
        "YIELD_TABLE_TENNENRIN_SHEET": "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
        "ABSORPTION_CALCULATION_IKUSEIRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "ABSORPTION_CALCULATION_TENNENRIN_SHEET": "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "EMISSION_CALCULATION_SHEET": "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "HWP_SHEET": "\u3010\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u3011\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "SYUBATU_AND_AFFORESTATION_SHEET": "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
        "AUTOMATIC_ABSORPTION_CALCULATION_SHEET": "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
        "CONFIRMATION_OF_APPLICATION_CONDITION_5_SHEET": "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef65\u306b\u4fc2\u308b\u78ba\u8a8d\u66f8",
        "CONFIRMATION_OF_APPLICATION_CONDITION_6_SHEET": "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef66\u306b\u4fc2\u308b\u8a93\u7d04\u66f8",
        "PROJECT_IMPLEMENTER_SHEET": "\u4ee3\u8868\u4ee5\u5916\u306e\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u3082\u3057\u304f\u306f\u30d7\u30ed\u30b0\u30e9\u30e0\u578b\u904b\u55b6\u30fb\u7ba1\u7406\u8005",
        "PROJECT_PLAN_SUBMISSION_DOCUMENTS": [
            "\u3010HP\u516c\u958b\u30117.\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u8a08\u753b\uff08FO-001\uff09",
            "\u767b\u9332\u7533\u8acb\u66f8",
            "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
            "\u68ee\u6797\u7d4c\u55b6\u8a08\u753b\u306e\u9069\u7528\u6761\u4ef6\uff11\u3078\u306e\u9069\u7528\u3068\u8a08\u753b\u306e\u5909\u9077\uff08FO-001\uff09",
            "\u3010HP\u516c\u958b\u30112.\u9069\u7528\u3059\u308b\u65b9\u6cd5\u8ad6\uff08FO-001\uff09",
            "\u3010HP\u516c\u958b\u30113.\u30c7\u30fc\u30bf\u7ba1\u7406",
            "5.\u8ffd\u52a0\u6027\u306b\u95a2\u3059\u308b\u60c5\u5831",
            "\u3010HP\u516c\u958b\u30114.\u7279\u8a18\u4e8b\u9805",
            "\u3010HP\u516c\u958b\u30111.\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u6982\u8981",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u80b2\u6210\u6797\u304a\u3088\u3073\u4e3b\u4f10\u7528\uff08001\u3001003\u5171\u901a\uff09",
            "\u5e79\u6750\u7a4d\u91cf\u7b97\u5b9a\u30b7\u30fc\u30c8_\u5929\u7136\u751f\u6797\uff08FO-001\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08\u5929\u7136\u751f\u6797\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u6392\u51fa\u91cf\uff08PJ\u5185\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010\u5438\u53ce\u91cf\uff08PJ\u5185HWP\uff09\u3011\u60c5\u5831\u8a18\u5165\u30fb\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\u3010\u4e3b\u4f10\u518d\u9020\u6797\uff08PJ\u5916\uff09\u7b97\u5b9a\u7528\u3011\u60c5\u5831\u8a18\u5165\u30b7\u30fc\u30c8\uff08FO-001\uff09",
            "\uff08\u81ea\u52d5\u8a08\u7b97\uff09\u5438\u53ce\u91cf\uff08\u80b2\u6210\u6797\uff09\u7b97\u5b9a\u30b7\u30fc\u30c8\uff08001\u3001003\u5171\u901a\uff09",
            "\u3010HP\u516c\u958b\u3011\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u8a08\u753b\u66f8\u8868\u7d19",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef65\u306b\u4fc2\u308b\u78ba\u8a8d\u66f8",
            "\uff08\u53c2\u8003\u69d8\u5f0f\uff09FO-001\u9069\u7528\u6761\u4ef66\u306b\u4fc2\u308b\u8a93\u7d04\u66f8",
            "\u4ee3\u8868\u4ee5\u5916\u306e\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u5b9f\u65bd\u8005\u3082\u3057\u304f\u306f\u30d7\u30ed\u30b0\u30e9\u30e0\u578b\u904b\u55b6\u30fb\u7ba1\u7406\u8005"
        ],
        "FOREST_AGE_INTERVAL_ONE_YEAR_EXCEL_COLUMN_INDEX": {
            "1": "B",
            "2": "F",
            "3": "J",
            "4": "N",
            "5": "R",
            "6": "V",
            "7": "Z",
            "8": "AD",
            "9": "AH",
            "10": "AL",
            "11": "AP",
            "12": "AT",
            "13": "AX",
            "14": "BB",
            "15": "BF",
            "16": "BJ",
            "17": "BN",
            "18": "BR",
            "19": "BV",
            "20": "BZ",
            "21": "CD",
            "22": "CH",
            "23": "CL",
            "24": "CP",
            "25": "CT",
            "26": "CX",
            "27": "DB",
            "28": "DF",
            "29": "DJ",
            "30": "DN",
            "31": "DR",
            "32": "DV",
            "33": "DZ",
            "34": "ED",
            "35": "EH",
            "36": "EL",
            "37": "EP",
            "38": "ET",
            "39": "EX",
            "40": "FB"
        },
        "FOREST_AGE_INTERVAL_TEN_YEAR_EXCEL_COLUMN_INDEX": {
            "1": "D",
            "2": "H",
            "3": "L",
            "4": "P",
            "5": "T",
            "6": "X",
            "7": "AB",
            "8": "AF",
            "9": "AJ",
            "10": "AN",
            "11": "AR",
            "12": "AV",
            "13": "AZ",
            "14": "BD",
            "15": "BH",
            "16": "BL",
            "17": "BP",
            "18": "BT",
            "19": "BX",
            "20": "CB",
            "21": "CF",
            "22": "CJ",
            "23": "CR",
            "24": "CV",
            "25": "CZ",
            "26": "DD",
            "27": "DH",
            "28": "DL",
            "29": "DP",
            "30": "DT",
            "31": "DX",
            "32": "EB",
            "33": "ED",
            "34": "EH",
            "35": "EL",
            "36": "EP",
            "37": "ET",
            "38": "EX",
            "39": "FB",
            "40": "FD"
        },
        "FOREST_AGE_INTERVAL_MARK": "\u25cb",
        "EXECUTION_REGION_OPTIONS": [
            {
                "value": "",
                "label": ""
            },
            {
                "value": "\u5317\u6d77\u9053",
                "label": "\u5317\u6d77\u9053"
            },
            {
                "value": "\u6771\u5317",
                "label": "\u6771\u5317"
            },
            {
                "value": "\u95a2\u6771",
                "label": "\u95a2\u6771"
            },
            {
                "value": "\u4e2d\u90e8",
                "label": "\u4e2d\u90e8"
            },
            {
                "value": "\u4e2d\u56fd",
                "label": "\u4e2d\u56fd"
            },
            {
                "value": "\u56db\u56fd",
                "label": "\u56db\u56fd"
            },
            {
                "value": "\u4e5d\u5dde\u30fb\u6c96\u7e04",
                "label": "\u4e5d\u5dde\u30fb\u6c96\u7e04"
            }
        ],
        "APPLICABLE_CONDITION5_DOCUMENT_TYPE_1": 1,
        "APPLICABLE_CONDITION5_DOCUMENT_TYPE_2": 2
    },
    "ProjectPlanningChangeAuthorizationsApplyPeriod": {
        "CHANGE_FROM_PROJECT_DOCUMENT_TYPE_NO_CHANGE": 1,
        "CHANGE_FROM_PROJECT_DOCUMENT_TYPE_CHANGE": 2,
        "CHANGE_FROM_PROJECT_DOCUMENT_DETAIL_TYPE_DONE": 1,
        "CHANGE_FROM_PROJECT_DOCUMENT_DETAIL_TYPE_PLANNING": 2,
        "PLANNED_OR_EXECUTION_CHANGE_TYPE_NO_CHANGE": 1,
        "PLANNED_OR_EXECUTION_CHANGE_TYPE_CHANGE": 2,
        "PLANNED_OR_EXECUTION_CHANGE_DETAIL_TYPE_CHANGE": 1,
        "PLANNED_OR_EXECUTION_CHANGE_DETAIL_TYPE_NEW": 2,
        "PLANNED_OR_EXECUTION_CHANGE_DETAIL_TYPE_OTHER": 3,
        "PERIOD_VALIDITY_WITHIN_CERTIFICATION_PERIOD": 1,
        "PERIOD_VALIDITY_WITHIN_CERTIFICATION_PERIOD_LABEL": "2.1\u306e\u8a8d\u8a3c\u5bfe\u8c61\u671f\u9593\u5185\u3067\u3042\u308b",
        "PERIOD_VALIDITY_NO_OVERLAP_WITH_PAST": 2,
        "PERIOD_VALIDITY_NO_OVERLAP_WITH_PAST_LABEL": "\u904e\u53bb\u306e\u8a8d\u8a3c\u6e08\u307f\u671f\u9593\u3068\u91cd\u8907\u304c\u306a\u3044",
        "PERIOD_VALIDITY_NO_FUTURE_PERIOD": 3,
        "PERIOD_VALIDITY_NO_FUTURE_PERIOD_LABEL": "\u691c\u8a3c\u7533\u8acb\u65e5\u4ee5\u964d\u306e\u671f\u9593\u304c\u542b\u307e\u308c\u3066\u3044\u306a\u3044",
        "PERIOD_VALIDITY_NO_OVERLAP_WITH_OTHER_SYSTEMS": 4,
        "PERIOD_VALIDITY_NO_OVERLAP_WITH_OTHER_SYSTEMS_LABEL": "\u4ed6\u306e\u985e\u4f3c\u5236\u5ea6\u3078\u306e\u8a8d\u8a3c\u7533\u8acb\u306e\u5bfe\u8c61\u671f\u9593\u3068\u91cd\u8907\u304c\u306a\u3044",
        "MONITORING_ORIENTATION_CHANGE_TYPE_NO_CHANGE": 1,
        "MONITORING_ORIENTATION_CHANGE_TYPE_CHANGE": 2,
        "MONITORING_FREQUENCY_SATISFY": 1,
        "MONITORING_FREQUENCY_NOT_SATISFY": 2
    },
    "Simulation": {
        "STATUS_NOT_RUN": 0,
        "STATUS_RUNNING": 1,
        "STATUS_SUCCESS": 2,
        "STATUS_FAILED": 3,
        "STATUS_LABELS": [
            "\u672a\u5b9f\u65bd",
            "\u5b9f\u884c\u4e2d",
            "\u6210\u529f",
            "\u5931\u6557"
        ],
        "CERTIFICATION_PERIOD_8_YEARS": 8,
        "CERTIFICATION_PERIOD_8_YEARS_LABEL": "8\u5e74",
        "CERTIFICATION_PERIOD_9_YEARS": 9,
        "CERTIFICATION_PERIOD_9_YEARS_LABEL": "9\u5e74",
        "CERTIFICATION_PERIOD_10_YEARS": 10,
        "CERTIFICATION_PERIOD_10_YEARS_LABEL": "10\u5e74",
        "CERTIFICATION_PERIOD_11_YEARS": 11,
        "CERTIFICATION_PERIOD_11_YEARS_LABEL": "11\u5e74",
        "CERTIFICATION_PERIOD_12_YEARS": 12,
        "CERTIFICATION_PERIOD_12_YEARS_LABEL": "12\u5e74",
        "CERTIFICATION_PERIOD_13_YEARS": 13,
        "CERTIFICATION_PERIOD_13_YEARS_LABEL": "13\u5e74",
        "CERTIFICATION_PERIOD_14_YEARS": 14,
        "CERTIFICATION_PERIOD_14_YEARS_LABEL": "14\u5e74",
        "CERTIFICATION_PERIOD_15_YEARS": 15,
        "CERTIFICATION_PERIOD_15_YEARS_LABEL": "15\u5e74",
        "CERTIFICATION_PERIOD_16_YEARS": 16,
        "CERTIFICATION_PERIOD_16_YEARS_LABEL": "16\u5e74",
        "CERTIFICATION_PERIOD_OPTIONS": [
            {
                "years": 8,
                "label": "8\u5e74"
            },
            {
                "years": 9,
                "label": "9\u5e74"
            },
            {
                "years": 10,
                "label": "10\u5e74"
            },
            {
                "years": 11,
                "label": "11\u5e74"
            },
            {
                "years": 12,
                "label": "12\u5e74"
            },
            {
                "years": 13,
                "label": "13\u5e74"
            },
            {
                "years": 14,
                "label": "14\u5e74"
            },
            {
                "years": 15,
                "label": "15\u5e74"
            },
            {
                "years": 16,
                "label": "16\u5e74"
            }
        ],
        "AREA_TYPE_ACTUAL_VALUE": 1,
        "AREA_TYPE_ESTIMATED_VALUE": 2,
        "AREA_TYPE_ACTUAL_LABEL": "\u5b9f\u6e2c\u5024",
        "AREA_TYPE_ESTIMATED_LABEL": "\u60f3\u5b9a\u5024",
        "AREA_TYPE_OPTIONS": [
            {
                "id": 1,
                "label": "\u5b9f\u6e2c\u5024"
            },
            {
                "id": 2,
                "label": "\u60f3\u5b9a\u5024"
            }
        ],
        "POSITION_TYPE_ACTUAL_VALUE": 1,
        "POSITION_TYPE_ESTIMATED_VALUE": 2,
        "POSITION_TYPE_ACTUAL_LABEL": "\u5b9f\u6e2c\u5024",
        "POSITION_TYPE_ESTIMATED_LABEL": "\u60f3\u5b9a\u5024",
        "POSITION_TYPE_OPTIONS": [
            {
                "id": 1,
                "label": "\u5b9f\u6e2c\u5024"
            },
            {
                "id": 2,
                "label": "\u60f3\u5b9a\u5024"
            }
        ],
        "BULK_APPLICATION_STATUS_FALSE": 0,
        "BULK_APPLICATION_STATUS_TRUE": 1,
        "BULK_APPLICATION_STATUS_FALSE_LABEL": "\u7121",
        "BULK_APPLICATION_STATUS_TRUE_LABEL": "\u6709",
        "BULK_APPLICATION_STATUS_OPTIONS": [
            {
                "id": 0,
                "label": "\u7121"
            },
            {
                "id": 1,
                "label": "\u6709"
            }
        ],
        "FOREST_PROTECTION_ACTIVITY_TYPE_PEST_CONTROL": 1,
        "FOREST_PROTECTION_ACTIVITY_TYPE_FIRE_PREVENTION": 2,
        "FOREST_PROTECTION_ACTIVITY_TYPE_PEST_CONTROL_LABEL": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632",
        "FOREST_PROTECTION_ACTIVITY_TYPE_FIRE_PREVENTION_LABEL": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5",
        "FOREST_PROTECTION_ACTIVITY_TYPE_OPTIONS": [
            {
                "id": 1,
                "label": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632"
            },
            {
                "id": 2,
                "label": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5"
            }
        ],
        "NATURAL_FOREST_PROTECTION_ACTIVITY_PEST_CONTROL": 1,
        "NATURAL_FOREST_PROTECTION_ACTIVITY_FIRE_PREVENTION": 2,
        "NATURAL_FOREST_PROTECTION_ACTIVITY_PEST_CONTROL_LABEL": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632",
        "NATURAL_FOREST_PROTECTION_ACTIVITY_FIRE_PREVENTION_LABEL": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5",
        "NATURAL_FOREST_PROTECTION_OPTIONS": [
            {
                "id": 1,
                "label": "\u68ee\u6797\u75c5\u5bb3\u866b\u306e\u99c6\u9664\u53ca\u3073\u4e88\u9632"
            },
            {
                "id": 2,
                "label": "\u706b\u707d\u306e\u4e88\u9632\u305d\u306e\u4ed6\u306e\u4fdd\u8b77\u6d3b\u52d5"
            }
        ],
        "RESULT_STATUS_UNCONFIRMED_KEY": 0,
        "RESULT_STATUS_UNCONFIRMED_LABEL": "\u672a\u78ba\u5b9a",
        "RESULT_STATUS_CONFIRMED_KEY": 1,
        "RESULT_STATUS_CONFIRMED_LABEL": "\u78ba\u5b9a\u6e08",
        "RESULT_STATUS_OPTIONS": [
            {
                "key": 0,
                "label": "\u672a\u78ba\u5b9a"
            },
            {
                "key": 1,
                "label": "\u78ba\u5b9a\u6e08"
            }
        ],
        "RESULT_STATUS_UNCONFIRMED": 0,
        "RESULT_STATUS_CONFIRMED": 1,
        "RESULT_STATUS_LABELS": [
            "\u672a\u78ba\u5b9a",
            "\u78ba\u5b9a\u6e08"
        ]
    },
    "SimulationItem": {
        "CLASSIFICATION_LABEL_COST": "\u8cbb\u7528",
        "CLASSIFICATION_LABEL_INCOME": "\u53ce\u5165",
        "UNIT_LABEL_YEN": "\u5186",
        "UNIT_LABEL_YEN_PER_HA": "\u5186\/ha",
        "UNIT_LABEL_YEN_PER_TON_CO2": "\u5186\/t-CO2"
    },
    "SimulationResult": {
        "STATUS_NOT_RUN": 0,
        "STATUS_RUNNING": 1,
        "STATUS_SUCCESS": 2,
        "STATUS_FAILED": 3,
        "STATUS_LABELS": [
            "\u672a\u5b9f\u65bd",
            "\u5b9f\u884c\u4e2d",
            "\u6210\u529f",
            "\u5931\u6557"
        ]
    },
    "SpatialFile": {
        "SAVING_FORMAT_SHAPE_FILE": "shape_file",
        "SAVING_FORMAT_GEO_JSON": "geo_json",
        "FILE_LOCATION_TYPE_S3": "s3",
        "FILE_LOCATION_TYPE_MAPBOX_STUDIO": "mapbox_studio",
        "STATUS_NOT_SET": {
            "key": 0,
            "text": "\u672a\u8a2d\u5b9a"
        },
        "STATUS_PROCESSING": {
            "key": 1,
            "text": "\u9032\u884c\u4e2d"
        },
        "STATUS_COMPLETED": {
            "key": 2,
            "text": "\u5b8c\u4e86"
        },
        "STATUS_ERROR": {
            "key": 99,
            "text": "\u30a8\u30e9\u30fc"
        },
        "STATUS_LIST": [
            {
                "key": 0,
                "text": "\u672a\u8a2d\u5b9a"
            },
            {
                "key": 1,
                "text": "\u9032\u884c\u4e2d"
            },
            {
                "key": 2,
                "text": "\u5b8c\u4e86"
            },
            {
                "key": 99,
                "text": "\u30a8\u30e9\u30fc"
            }
        ],
        "MAP_TILE_STATUS_NOT_DONE": 0,
        "MAP_TILE_STATUS_DONE": 1,
        "MAP_TILE_STATUS_LIST": [
            0,
            1
        ],
        "MEMBER_SPATIAL_FILE_NOT_USING": 0,
        "MEMBER_SPATIAL_FILE_USING": 1
    },
    "TrunkVolumeParameter": {
        "YEARLY_OVERRIDE_FIELDS": [
            "sawmill_yield",
            "plywood_yield",
            "construction_sawmill_ratio",
            "non_construction_sawmill_ratio",
            "construction_plywood_ratio",
            "non_construction_plywood_ratio"
        ]
    },
    "User": {
        "GENDER_MAN": "man",
        "GENDER_WOMAN": "woman",
        "GENDER_OTHER": "other",
        "STATUS_PROVISIONED": "provisioned",
        "STATUS_REGISTERED": "registered",
        "STATUS_SUSPENDED": "suspended",
        "STATUS_DELETED": "deleted"
    },
    "UserProfileImage": {
        "FOREIGN_ID": "user_id",
        "FILE_NAME_LENGTH": 20
    },
    "UserVerificationToken": {
        "REGISTRATION_TOKEN_EXPIRATION": 1,
        "PURPOSE_REGISTRATION": "registration",
        "PURPOSE_PASSWORD_RESET": "password_reset",
        "PURPOSE_EMAIL_RESET": "email_reset"
    }
};
